(function () {
  function kfTrack(name, params) {
    try {
      if (typeof window.gtag === 'function') {
        window.gtag('event', name, params || {});
      }
    } catch (e) { /* analytics must never break the configurator */ }
  }

  // --- English translation layer -------------------------------------------
  // The spec JSON (question/answer names) and this file's UI strings are
  // authored in French. Rather than maintaining translated copies of every
  // kf-spec-*.json file, we translate at render time: the underlying data
  // (ids, config keys, buildLineItemProperties, cart matching) always stays
  // French — only what gets written into the DOM is translated when the
  // shopper's locale is English.
  function kfIsEnglish() {
    var lang = (document.documentElement.lang || '').toLowerCase();
    return lang.indexOf('en') === 0;
  }
  function kfIsSpanish() {
    var lang = (document.documentElement.lang || '').toLowerCase();
    return lang.indexOf('es') === 0;
  }
  function kfIsItalian() {
    var lang = (document.documentElement.lang || '').toLowerCase();
    return lang.indexOf('it') === 0;
  }
  function kfIsGerman() {
    var lang = (document.documentElement.lang || '').toLowerCase();
    return lang.indexOf('de') === 0;
  }
  function kfIsDutch() {
    var lang = (document.documentElement.lang || '').toLowerCase();
    return lang.indexOf('nl') === 0;
  }
  function kfIsHebrew() {
    var lang = (document.documentElement.lang || '').toLowerCase();
    return lang.indexOf('he') === 0 || lang.indexOf('iw') === 0;
  }
  function kfIsArabic() {
    var lang = (document.documentElement.lang || '').toLowerCase();
    return lang.indexOf('ar') === 0;
  }
  function kfIsPortuguese() {
    var lang = (document.documentElement.lang || '').toLowerCase();
    return lang.indexOf('pt') === 0;
  }
  function kfIsBrazilian() {
    var lang = (document.documentElement.lang || '').toLowerCase();
    return lang.indexOf('pt-br') === 0;
  }

  // Compositional word/phrase dictionary, applied longest-match-first so
  // e.g. "Carbone Forgé" is translated as a unit before bare "Carbone" is.
  var KF_WORD_MAP = [
    ["carbone forgé", "Forged Carbon"], ["carbon forgé", "Forged Carbon"], ["carbone forge", "Forged Carbon"],
    ["cuir lisse", "Smooth Leather"], ["cuir perforé", "Perforated Leather"],
    ["fibre sergé", "Twill Carbon"], ["fibre sergée", "Twill Carbon"],
    ["nid d'abeilles", "Honeycomb"],
    ["noir brillant", "Gloss Black"], ["noir matte", "Matte Black"], ["noir mat", "Matte Black"], ["noire mat", "Matte Black"],
    ["bleu ciel", "Sky Blue"],
    ["volant chauffant", "Heated Steering Wheel"],
    ["s-line noir", "S-Line Black"], ["s-line", "S-Line"], ["r-line", "R-Line"],
    ["m performance", "M Performance"],
    ["r32 noir", "R32 Black"], ["gti noir", "GTI Black"], ["gti rouge", "GTI Red"],
    ["rs noir", "RS Black"], ["s noir", "S Black"],
    ["cuir", "Leather"], ["alcantara", "Alcantara"], ["carbone", "Carbon"], ["carbon", "Carbon"], ["forgé", "Forged"], ["forge", "Forged"],
    ["argenté", "Silver"], ["argent", "Silver"],
    ["doré", "Gold"],
    ["noire", "Black"], ["noir", "Black"],
    ["blanche", "White"], ["blanc", "White"],
    ["bleu", "Blue"],
    ["rouge", "Red"],
    ["verte", "Green"], ["vert", "Green"],
    ["jaune", "Yellow"],
    ["rose", "Pink"],
    ["violet", "Purple"],
    ["grise", "Grey"], ["gris", "Grey"],
    ["marron", "Brown"],
    ["beige", "Beige"],
    ["orange", "Orange"],
    ["bordeaux", "Burgundy"],
    ["mat", "Matte"], ["matte", "Matte"],
    ["oui", "Yes"], ["non", "No"],
    ["avec", "With"], ["sans", "Without"],
    ["aucun", "None"], ["aucune", "None"],
    ["allemagne", "Germany"],
    ["line assist", "Line Assist"],
    ["et", "and"]
  ].sort(function (a, b) { return b[0].length - a[0].length; });

  // --- Spanish layer (mirrors the English one; data stays French) ---------
  function kfNormKey(t) { return t.trim().toLowerCase().replace(/\s+/g, ' ').replace(/\s+\?/g, '?').replace(/al+[eé]g[eé]e?/g, 'allege'); }
  var KF_PHRASE_MAP_ES_RAW = [
    ["forme du volant", "Forma del volante"],
    ["type de poignées", "Tipo de empuñaduras"],
    ["poignées en cuir perforé", "Empuñaduras de cuero perforado"],
    ["poignées cuir perforé", "Empuñaduras de cuero perforado"],
    ["poignées en cuir lisse", "Empuñaduras de cuero liso"],
    ["poignées cuir lisse", "Empuñaduras de cuero liso"],
    ["poignées en alcantara", "Empuñaduras de Alcantara"],
    ["poignées alcantara", "Empuñaduras de Alcantara"],
    ["type d'insert", "Tipo de inserto"],
    ["insert en cuir lisse", "Inserto de cuero liso"],
    ["insert cuir lisse", "Inserto de cuero liso"],
    ["insert cuir", "Inserto de cuero"],
    ["insert en alcantara", "Inserto de Alcantara"],
    ["insert alcantara", "Inserto de Alcantara"],
    ["insert en carbone", "Inserto de carbono"],
    ["insert carbone", "Inserto de carbono"],
    ["insert en carbone forgé", "Inserto de carbono forjado"],
    ["insert carbone forgé", "Inserto de carbono forjado"],
    ["couleur des surpiqures (pas visible sur le configurateur)", "Color de las costuras (no visible en el configurador)"],
    ["couleur des surpiqures", "Color de las costuras"],
    ["couleur des surpiqures du cache airbag", "Color de las costuras de la tapa del airbag"],
    ["rappel 12h", "Marca de las 12 h"],
    ["personnaliser le cache airbag ?", "¿Personalizar la tapa del airbag?"],
    ["matière cache airbag", "Material de la tapa del airbag"],
    ["couleur du logo", "Color del logo"],
    ["shiftled", "ShiftLed"],
    ["boîte automatique?", "¿Caja de cambios automática?"],
    ["palettes txcp", "Levas TXCP"],
    ["couleur palettes carbone", "Color de las levas de carbono"],
    ["couleur palettes carbone allegee", "Color de las levas de carbono aligerado"],
    ["couleur palettes allegee", "Color de las levas de carbono aligerado"],
    ["couleur palettes carbone forgé", "Color de las levas de carbono forjado"],
    ["avez-vous l'option volant chauffant?", "¿Su vehículo tiene la opción de volante calefactable?"],
    ["ajout du pack volant complet (commande au volant, électronique de palette, airbag complet)", "Añadir el pack de volante completo (mandos del volante, electrónica de las levas, airbag completo)"],
    ["ajout du pack volant complet (électronique de palette, airbag complet)", "Añadir el pack de volante completo (electrónica de las levas, airbag completo)"],
    ["modèle du véhicule et indiquez vos préférences de configuration (surpiqûres, couleur du rappel 12:00, style de carbone,etc.). nous en tiendrons compte lors de la fabrication.", "Modelo del vehículo e indique sus preferencias de configuración (costuras, color de la marca de las 12:00, estilo de carbono, etc.). Las tendremos en cuenta durante la fabricación."],
    ["envoyez une photo de votre volant actuel", "Envíe una foto de su volante actual"],
    ["personnaliser le contour des boutons ?", "¿Personalizar el contorno de los botones?"],
    ["contours des boutons", "Contornos de los botones"],
    ["logo", "Logotipo"],
    ["couleur des lettres du logo", "Color de las letras del logotipo"],
    ["couleur logo", "Color del logotipo"],
    ["bouton style r8", "Botón estilo R8"],
    ["logo insert", "Inserto con logotipo"],
    ["garniture supplémentaire", "Moldura adicional"],
    ["garnitures supplémentaires", "Molduras adicionales"],
    ["coutures cache airbag", "Costuras de la tapa del airbag"],
    ["personnaliser la garniture centrale", "¿Personalizar la moldura central?"],
    ["personnaliser la garniture centrale ?", "¿Personalizar la moldura central?"],
    ["personnaliser les garnitures ?", "¿Personalizar las molduras?"],
    ["couleur garnitures", "Color de las molduras"],
    ["matière garniture centrale", "Material de la moldura central"],
    ["votre véhicule a t'il l'option line assist ? (volant vibrant) ou volant chauffant?", "¿Su vehículo tiene la opción Line Assist (volante vibrante) o volante calefactable?"],
    ["ronde", "Redonda"],
    ["méplat", "Fondo plano"],
    ["sportive", "Deportiva"]
  ];
  var KF_PHRASE_MAP_ES = {};
  KF_PHRASE_MAP_ES_RAW.forEach(function (p) { KF_PHRASE_MAP_ES[kfNormKey(p[0])] = p[1]; });
  var KF_WORD_MAP_ES = [
    ["carbone forgé", "carbono forjado"],
    ["carbon forgé", "carbono forjado"],
    ["carbone forge", "carbono forjado"],
    ["carbone allégé", "carbono aligerado"],
    ["carbone noir nid d'abeilles", "carbono negro nido de abeja"],
    ["nid d'abeilles", "nido de abeja"],
    ["cuir perforé", "cuero perforado"],
    ["cuir perfore", "cuero perforado"],
    ["cuir lisse", "cuero liso"],
    ["cuir surpiqué", "cuero con costuras"],
    ["fibre sergé", "fibra sarga"],
    ["fibre sergée", "fibra sarga"],
    ["bleu ciel", "azul cielo"],
    ["noir brillant", "negro brillante"],
    ["noir matte", "negro mate"],
    ["noir mat", "negro mate"],
    ["noire mat", "negra mate"],
    ["rouge mat", "rojo mate"],
    ["argenté mat", "plateado mate"],
    ["volant chauffant", "volante calefactable"],
    ["m performance", "M Performance"],
    ["cuir", "cuero"],
    ["alcantara", "Alcantara"],
    ["carbone", "carbono"],
    ["carbon", "carbono"],
    ["caborne", "carbono"],
    ["forgé", "forjado"],
    ["forge", "forjado"],
    ["argenté", "plateado"],
    ["argent", "plata"],
    ["doré", "dorado"],
    ["or", "oro"],
    ["noire", "negra"],
    ["noir", "negro"],
    ["blanche", "blanca"],
    ["blanc", "blanco"],
    ["bleu", "azul"],
    ["rouge", "rojo"],
    ["verte", "verde"],
    ["vert", "verde"],
    ["jaune", "amarillo"],
    ["rose", "rosa"],
    ["violet", "violeta"],
    ["grise", "gris"],
    ["gris", "gris"],
    ["marron", "marrón"],
    ["beige", "beige"],
    ["orange", "naranja"],
    ["bordeaux", "burdeos"],
    ["mat", "mate"],
    ["matte", "mate"],
    ["brillant", "brillante"],
    ["oui", "Sí"],
    ["non", "No"],
    ["avec", "Con"],
    ["sans", "Sin"],
    ["aucun", "Ninguno"],
    ["aucune", "Ninguna"],
    ["allemagne", "Alemania"],
    ["aluminium", "Aluminio"],
    ["untitled answer", "Sin título"]
  ].sort(function (a, b) { return b[0].length - a[0].length; });
  var KF_UI_STRINGS_ES = {
    "Valider la configuration": "Validar la configuración",
    "Ajouter au panier": "Añadir al carrito",
    "Suivant": "Siguiente",
    "Préparation de votre configuration…": "Preparando su configuración…",
    "Ajout en cours…": "Añadiendo…",
    "Erreur — réessayez": "Error, inténtelo de nuevo",
    "Merci de répondre avant de continuer.": "Responda antes de continuar.",
    "Configurateur bientôt disponible": "Configurador próximamente disponible",
    "Choisir un fichier": "Elegir un archivo",
    "En savoir plus": "Saber más",
    "Chargement…": "Cargando…",
    "Impossible de charger le guide. ": "No se ha podido cargar la guía. ",
    "Ouvrir dans un nouvel onglet": "Abrir en una pestaña nueva",
    "Préparation du configurateur…": "Preparando el configurador…",
    "Fermer": "Cerrar",
    "Question précédente": "Pregunta anterior",
    "(envoi…)": "(enviando…)",
    "Le configurateur n'affiche qu'un rendu en forme méplat. Si vous choisissez la forme ronde, votre volant sera bien fabriqué dans cette forme.": "El configurador solo muestra una vista con la forma de fondo plano. Si elige la forma redonda, su volante se fabricará igualmente con esa forma.",
    "Vous pouvez tout de même faire vos choix ci-dessous : nous vous enverrons un rendu de votre volant une fois la commande passée, ou dès maintenant si vous préférez :": "Aun así, puede hacer sus elecciones a continuación: le enviaremos una vista de su volante una vez realizado el pedido, o ahora mismo si lo prefiere:",
    "Recevoir un aperçu avant de commander": "Recibir una vista previa antes de pedir",
    "Recevoir ma maquette": "Recibir mi maqueta",
    "Choose an option": "Elija una opción",
    "Année + Modèle et Personnalisation": "Año + Modelo y personalización"
  };
  function kfTranslateEs(text) {
    var trimmed = text.trim().replace(/\s+/g, ' ');
    var key = kfNormKey(trimmed);
    var result;
    if (KF_PHRASE_MAP_ES.hasOwnProperty(key)) {
      result = KF_PHRASE_MAP_ES[key];
    } else {
      result = trimmed.replace(/al+[eé]g[eé]e?/gi, 'allégé');
      for (var i = 0; i < KF_WORD_MAP_ES.length; i++) {
        var re = new RegExp('(^|\\s)(' + KF_WORD_MAP_ES[i][0].replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + ')($|\\s)', 'gi');
        var out = KF_WORD_MAP_ES[i][1];
        result = result.replace(re, function (m, p1, w, p2) {
          var o = (w.length > 1 && w === w.toUpperCase() && w !== w.toLowerCase()) ? out.toUpperCase() : out;
          return p1 + o + p2;
        });
      }
      if (/^[A-Za-zÀ-ÿ]/.test(trimmed)) result = result.charAt(0).toUpperCase() + result.slice(1);
    }
    return result;
  }
  // ---------------------------------------------------------------------

  // --- Italian layer (mirrors the Spanish one; data stays French) --------
  var KF_PHRASE_MAP_IT_RAW = [
    ["forme du volant", "Forma del volante"],
    ["type de poignées", "Tipo di impugnature"],
    ["poignées en cuir perforé", "Impugnature in pelle forata"],
    ["poignées cuir perforé", "Impugnature in pelle forata"],
    ["poignées en cuir lisse", "Impugnature in pelle liscia"],
    ["poignées cuir lisse", "Impugnature in pelle liscia"],
    ["poignées en alcantara", "Impugnature in Alcantara"],
    ["poignées alcantara", "Impugnature in Alcantara"],
    ["type d'insert", "Tipo di inserto"],
    ["insert en cuir lisse", "Inserto in pelle liscia"],
    ["insert cuir lisse", "Inserto in pelle liscia"],
    ["insert cuir", "Inserto in pelle"],
    ["insert en alcantara", "Inserto in Alcantara"],
    ["insert alcantara", "Inserto in Alcantara"],
    ["insert en carbone", "Inserto in carbonio"],
    ["insert carbone", "Inserto in carbonio"],
    ["insert en carbone forgé", "Inserto in carbonio forgiato"],
    ["insert carbone forgé", "Inserto in carbonio forgiato"],
    ["couleur des surpiqures (pas visible sur le configurateur)", "Colore delle impunture (non visibile nel configuratore)"],
    ["couleur des surpiqures", "Colore delle impunture"],
    ["couleur des surpiqures du cache airbag", "Colore delle impunture della cover airbag"],
    ["rappel 12h", "Segno delle 12"],
    ["personnaliser le cache airbag ?", "Personalizzare la cover airbag?"],
    ["matière cache airbag", "Materiale della cover airbag"],
    ["couleur du logo", "Colore del logo"],
    ["shiftled", "ShiftLed"],
    ["boîte automatique?", "Cambio automatico?"],
    ["palettes txcp", "Paddle TXCP"],
    ["couleur palettes carbone", "Colore dei paddle in carbonio"],
    ["couleur palettes carbone allegee", "Colore dei paddle in carbonio alleggerito"],
    ["couleur palettes allegee", "Colore dei paddle in carbonio alleggerito"],
    ["couleur palettes carbone forgé", "Colore dei paddle in carbonio forgiato"],
    ["avez-vous l'option volant chauffant?", "Il tuo veicolo ha l'opzione volante riscaldato?"],
    ["ajout du pack volant complet (commande au volant, électronique de palette, airbag complet)", "Aggiunta del pack volante completo (comandi al volante, elettronica dei paddle, airbag completo)"],
    ["ajout du pack volant complet (électronique de palette, airbag complet)", "Aggiunta del pack volante completo (elettronica dei paddle, airbag completo)"],
    ["modèle du véhicule et indiquez vos préférences de configuration (surpiqûres, couleur du rappel 12:00, style de carbone,etc.). nous en tiendrons compte lors de la fabrication.", "Modello del veicolo e indica le tue preferenze di configurazione (impunture, colore del segno delle 12:00, stile del carbonio, ecc.). Ne terremo conto durante la produzione."],
    ["envoyez une photo de votre volant actuel", "Invia una foto del tuo volante attuale"],
    ["personnaliser le contour des boutons ?", "Personalizzare il contorno dei pulsanti?"],
    ["contours des boutons", "Contorni dei pulsanti"],
    ["logo", "Logo"],
    ["couleur des lettres du logo", "Colore delle lettere del logo"],
    ["couleur logo", "Colore del logo"],
    ["bouton style r8", "Pulsante stile R8"],
    ["logo insert", "Inserto con logo"],
    ["garniture supplémentaire", "Modanatura aggiuntiva"],
    ["garnitures supplémentaires", "Modanature aggiuntive"],
    ["coutures cache airbag", "Cuciture della cover airbag"],
    ["personnaliser la garniture centrale", "Personalizzare la modanatura centrale?"],
    ["personnaliser la garniture centrale ?", "Personalizzare la modanatura centrale?"],
    ["personnaliser les garnitures ?", "Personalizzare le modanature?"],
    ["couleur garnitures", "Colore delle modanature"],
    ["matière garniture centrale", "Materiale della modanatura centrale"],
    ["votre véhicule a t'il l'option line assist ? (volant vibrant) ou volant chauffant?", "Il tuo veicolo ha l'opzione Line Assist? (volante vibrante) o volante riscaldato?"],
    ["ronde", "Rotonda"],
    ["méplat", "Fondo piatto"],
    ["sportive", "Sportiva"]
  ];
  var KF_PHRASE_MAP_IT = {};
  KF_PHRASE_MAP_IT_RAW.forEach(function (p) { KF_PHRASE_MAP_IT[kfNormKey(p[0])] = p[1]; });
  var KF_UI_STRINGS_IT = {
    "Valider la configuration": "Convalida la configurazione",
    "Ajouter au panier": "Aggiungi al carrello",
    "Suivant": "Avanti",
    "Préparation de votre configuration…": "Preparazione della tua configurazione…",
    "Ajout en cours…": "Aggiunta in corso…",
    "Erreur — réessayez": "Errore, riprova",
    "Merci de répondre avant de continuer.": "Rispondi prima di continuare.",
    "Configurateur bientôt disponible": "Configuratore presto disponibile",
    "Choisir un fichier": "Scegli un file",
    "En savoir plus": "Scopri di più",
    "Chargement…": "Caricamento…",
    "Impossible de charger le guide. ": "Impossibile caricare la guida. ",
    "Ouvrir dans un nouvel onglet": "Apri in una nuova scheda",
    "Préparation du configurateur…": "Preparazione del configuratore…",
    "Fermer": "Chiudi",
    "Question précédente": "Domanda precedente",
    "(envoi…)": "(invio in corso…)",
    "Le configurateur n'affiche qu'un rendu en forme méplat. Si vous choisissez la forme ronde, votre volant sera bien fabriqué dans cette forme.": "Il configuratore mostra solo un rendering con la forma a fondo piatto. Se scegli la forma rotonda, il tuo volante verrà comunque prodotto con quella forma.",
    "Vous pouvez tout de même faire vos choix ci-dessous : nous vous enverrons un rendu de votre volant une fois la commande passée, ou dès maintenant si vous préférez :": "Puoi comunque fare le tue scelte qui sotto: ti invieremo un rendering del tuo volante dopo l'ordine, oppure subito se preferisci:",
    "Recevoir un aperçu avant de commander": "Ricevi un'anteprima prima di ordinare",
    "Recevoir ma maquette": "Ricevi il mio rendering",
    "Choose an option": "Scegli un'opzione",
    "Année + Modèle et Personnalisation": "Anno + Modello e personalizzazione"
  };

  var KF_IT_MATERIALS = [
    ["carbone noir nid d'abeilles", "carbonio nero a nido d'ape", 'm'],
    ["carbone forgé", "carbonio forgiato", 'm'], ["carbon forgé", "carbonio forgiato", 'm'], ["carbone forge", "carbonio forgiato", 'm'],
    ["carbone allégé", "carbonio alleggerito", 'm'], ["carbone allege", "carbonio alleggerito", 'm'],
    ["fibre sergée", "fibra twill", 'f'], ["fibre sergé", "fibra twill", 'f'],
    ["cuir perforé", "pelle forata", 'f'], ["cuir perfore", "pelle forata", 'f'], ["cuir lisse", "pelle liscia", 'f'], ["cuir surpiqué", "pelle con impunture", 'f'],
    ["forgé", "forgiato", 'm'], ["forge", "forgiato", 'm'],
    ["carbone", "carbonio", 'm'], ["carbon", "carbonio", 'm'], ["caborne", "carbonio", 'm'],
    ["alcantara", "Alcantara", 'f'], ["cuir", "pelle", 'f'], ["aluminium", "alluminio", 'm']
  ];
  // [french, masculine, feminine]
  var KF_IT_COLORS = [
    ["bleu ciel", "azzurro", "azzurra"], ["noir brillant", "nero lucido", "nera lucida"], ["noire brillante", "nera lucida", "nera lucida"],
    ["noir matte", "nero opaco", "nera opaca"], ["noir mat", "nero opaco", "nera opaca"], ["noire mat", "nera opaca", "nera opaca"],
    ["rouge mat", "rosso opaco", "rossa opaca"], ["argenté mat", "argento opaco", "argento opaco"],
    ["noire", "nera", "nera"], ["noir", "nero", "nera"], ["blanche", "bianca", "bianca"], ["blanc", "bianco", "bianca"],
    ["bleu", "blu", "blu"], ["rouge", "rosso", "rossa"], ["verte", "verde", "verde"], ["vert", "verde", "verde"],
    ["jaune", "giallo", "gialla"], ["rose", "rosa", "rosa"], ["violet", "viola", "viola"], ["grise", "grigia", "grigia"], ["gris", "grigio", "grigia"],
    ["marron", "marrone", "marrone"], ["beige", "beige", "beige"], ["orange", "arancione", "arancione"], ["bordeaux", "bordeaux", "bordeaux"],
    ["argenté", "argento", "argento"], ["argent", "argento", "argento"], ["doré", "oro", "oro"], ["or", "oro", "oro"],
    ["matte", "opaco", "opaca"], ["mat", "opaco", "opaca"], ["brillant", "lucido", "lucida"]
  ];
  var KF_IT_MISC = {
    'oui': 'Sì', 'non': 'No', 'avec': 'Con', 'sans': 'Senza', 'aucun': 'Nessuno', 'aucune': 'Nessuna',
    'allemagne': 'Germania', 'untitled answer': 'Senza titolo', 'volant chauffant': 'Volante riscaldato', 'm performance': 'M Performance'
  };
  function kfItAnswer(text) {
    var t = text.trim().replace(/\s+/g, ' ').replace(/al+[eé]g[eé]e?/gi, 'allégé');
    if (!t) return null;
    var low = t.toLowerCase();
    if (KF_IT_MISC.hasOwnProperty(low)) return KF_IT_MISC[low];
    var upper = t.length > 1 && t === t.toUpperCase() && t !== t.toLowerCase();
    var rest = low, out = [], gender = null, changed = false, m;
    for (var i = 0; i < KF_IT_MATERIALS.length; i++) {
      var mat = KF_IT_MATERIALS[i];
      if (rest === mat[0] || rest.indexOf(mat[0] + ' ') === 0) {
        out.push(mat[1]); gender = mat[2]; rest = rest.slice(mat[0].length).trim(); changed = true; break;
      }
    }
    while (rest) {
      var hit = null;
      for (var j = 0; j < KF_IT_COLORS.length; j++) {
        var c = KF_IT_COLORS[j];
        if (rest === c[0] || rest.indexOf(c[0] + ' ') === 0) { hit = c; break; }
      }
      if (hit) {
        var fem = gender ? gender === 'f' : /^(noire|blanche|grise|verte|brillante)/.test(hit[0]);
        out.push(fem ? hit[2] : hit[1]); rest = rest.slice(hit[0].length).trim(); changed = true;
      } else {
        var sp = rest.indexOf(' ');
        var tok = sp === -1 ? rest : rest.slice(0, sp);
        var origTok = t.slice(t.length - rest.length, t.length - rest.length + tok.length);
        out.push(origTok); rest = sp === -1 ? '' : rest.slice(sp + 1).trim();
      }
    }
    if (!changed) return null;
    var res = out.join(' ');
    if (upper) return res.toUpperCase();
    return res.charAt(0).toUpperCase() + res.slice(1);
  }
  function kfTranslateIt(text) {
    var trimmed = text.trim().replace(/\s+/g, ' ');
    var key = kfNormKey(trimmed);
    if (KF_PHRASE_MAP_IT.hasOwnProperty(key)) return KF_PHRASE_MAP_IT[key];
    var res = kfItAnswer(trimmed);
    return res === null ? trimmed : res;
  }
  // ---------------------------------------------------------------------

  // --- Portuguese layer (pt-PT and pt-BR; mirrors the Italian one; data stays French) ---
  var KF_PHRASE_MAP_PT_RAW = kfIsBrazilian() ? [["forme du volant", "Forma do volante"], ["type de poignées", "Tipo de pegadas"], ["poignées en cuir perforé", "Pegadas em couro perfurado"], ["poignées cuir perforé", "Pegadas em couro perfurado"], ["poignées en cuir lisse", "Pegadas em couro liso"], ["poignées cuir lisse", "Pegadas em couro liso"], ["poignées en alcantara", "Pegadas em Alcantara"], ["poignées alcantara", "Pegadas em Alcantara"], ["type d'insert", "Tipo de insert"], ["insert en cuir lisse", "Insert em couro liso"], ["insert cuir lisse", "Insert em couro liso"], ["insert cuir", "Insert em couro"], ["insert en alcantara", "Insert em Alcantara"], ["insert alcantara", "Insert em Alcantara"], ["insert en carbone", "Insert em carbono"], ["insert carbone", "Insert em carbono"], ["insert en carbone forgé", "Insert em carbono forjado"], ["insert carbone forgé", "Insert em carbono forjado"], ["couleur des surpiqures (pas visible sur le configurateur)", "Cor das costuras (não visível no configurador)"], ["couleur des surpiqures", "Cor das costuras"], ["couleur des surpiqures du cache airbag", "Cor das costuras da tampa do airbag"], ["rappel 12h", "Marca das 12h"], ["personnaliser le cache airbag ?", "Personalizar a tampa do airbag?"], ["matière cache airbag", "Material da tampa do airbag"], ["couleur du logo", "Cor do logotipo"], ["shiftled", "ShiftLed"], ["boîte automatique?", "Caixa automática?"], ["palettes txcp", "Aletas TXCP"], ["couleur palettes carbone", "Cor das aletas em carbono"], ["couleur palettes carbone allegee", "Cor das aletas em carbono leve"], ["couleur palettes allegee", "Cor das aletas em carbono leve"], ["couleur palettes carbone forgé", "Cor das aletas em carbono forjado"], ["avez-vous l'option volant chauffant?", "Seu veículo tem a opção de volante aquecido?"], ["ajout du pack volant complet (commande au volant, électronique de palette, airbag complet)", "Adição do pack de volante completo (comandos do volante, eletrônica das aletas, airbag completo)"], ["ajout du pack volant complet (électronique de palette, airbag complet)", "Adição do pack de volante completo (eletrônica das aletas, airbag completo)"], ["modèle du véhicule et indiquez vos préférences de configuration (surpiqûres, couleur du rappel 12:00, style de carbone,etc.). nous en tiendrons compte lors de la fabrication.", "Modelo do veículo e indique suas preferências de configuração (costuras, cor da marca das 12h, estilo de carbono, etc.). Teremos isso em conta durante a fabricação."], ["envoyez une photo de votre volant actuel", "Envie uma fotografia do seu volante atual"], ["personnaliser le contour des boutons ?", "Personalizar o contorno dos botões?"], ["contours des boutons", "Contornos dos botões"], ["logo", "Logotipo"], ["couleur des lettres du logo", "Cor das letras do logotipo"], ["couleur logo", "Cor do logotipo"], ["bouton style r8", "Botão estilo R8"], ["logo insert", "Insert com logotipo"], ["garniture supplémentaire", "Moldura adicional"], ["garnitures supplémentaires", "Molduras adicionais"], ["coutures cache airbag", "Costuras da tampa do airbag"], ["personnaliser la garniture centrale", "Personalizar a moldura central?"], ["personnaliser les garnitures ?", "Personalizar as molduras?"], ["couleur garnitures", "Cor das molduras"], ["matière garniture centrale", "Material da moldura central"], ["votre véhicule a t'il l'option line assist ? (volant vibrant) ou volant chauffant?", "Seu veículo tem a opção Line Assist? (volante vibratório) ou volante aquecido?"], ["ronde", "Redondo"], ["méplat", "Base plana"], ["sportive", "Esportivo"], ["personnaliser la garniture centrale ?", "Personalizar a moldura central?"]] : [["forme du volant", "Forma do volante"], ["type de poignées", "Tipo de pegas"], ["poignées en cuir perforé", "Pegas em pele perfurada"], ["poignées cuir perforé", "Pegas em pele perfurada"], ["poignées en cuir lisse", "Pegas em pele lisa"], ["poignées cuir lisse", "Pegas em pele lisa"], ["poignées en alcantara", "Pegas em Alcantara"], ["poignées alcantara", "Pegas em Alcantara"], ["type d'insert", "Tipo de insert"], ["insert en cuir lisse", "Insert em pele lisa"], ["insert cuir lisse", "Insert em pele lisa"], ["insert cuir", "Insert em pele"], ["insert en alcantara", "Insert em Alcantara"], ["insert alcantara", "Insert em Alcantara"], ["insert en carbone", "Insert em carbono"], ["insert carbone", "Insert em carbono"], ["insert en carbone forgé", "Insert em carbono forjado"], ["insert carbone forgé", "Insert em carbono forjado"], ["couleur des surpiqures (pas visible sur le configurateur)", "Cor das costuras (não visível no configurador)"], ["couleur des surpiqures", "Cor das costuras"], ["couleur des surpiqures du cache airbag", "Cor das costuras da tampa do airbag"], ["rappel 12h", "Marca das 12h"], ["personnaliser le cache airbag ?", "Personalizar a tampa do airbag?"], ["matière cache airbag", "Material da tampa do airbag"], ["couleur du logo", "Cor do logótipo"], ["shiftled", "ShiftLed"], ["boîte automatique?", "Caixa automática?"], ["palettes txcp", "Patilhas TXCP"], ["couleur palettes carbone", "Cor das patilhas em carbono"], ["couleur palettes carbone allegee", "Cor das patilhas em carbono leve"], ["couleur palettes allegee", "Cor das patilhas em carbono leve"], ["couleur palettes carbone forgé", "Cor das patilhas em carbono forjado"], ["avez-vous l'option volant chauffant?", "O seu veículo tem a opção de volante aquecido?"], ["ajout du pack volant complet (commande au volant, électronique de palette, airbag complet)", "Adição do pack de volante completo (comandos do volante, eletrónica das patilhas, airbag completo)"], ["ajout du pack volant complet (électronique de palette, airbag complet)", "Adição do pack de volante completo (eletrónica das patilhas, airbag completo)"], ["modèle du véhicule et indiquez vos préférences de configuration (surpiqûres, couleur du rappel 12:00, style de carbone,etc.). nous en tiendrons compte lors de la fabrication.", "Modelo do veículo e indique as suas preferências de configuração (costuras, cor da marca das 12h, estilo de carbono, etc.). Teremos isso em conta durante o fabrico."], ["envoyez une photo de votre volant actuel", "Envie uma fotografia do seu volante atual"], ["personnaliser le contour des boutons ?", "Personalizar o contorno dos botões?"], ["contours des boutons", "Contornos dos botões"], ["logo", "Logótipo"], ["couleur des lettres du logo", "Cor das letras do logótipo"], ["couleur logo", "Cor do logótipo"], ["bouton style r8", "Botão estilo R8"], ["logo insert", "Insert com logótipo"], ["garniture supplémentaire", "Moldura adicional"], ["garnitures supplémentaires", "Molduras adicionais"], ["coutures cache airbag", "Costuras da tampa do airbag"], ["personnaliser la garniture centrale", "Personalizar a moldura central?"], ["personnaliser les garnitures ?", "Personalizar as molduras?"], ["couleur garnitures", "Cor das molduras"], ["matière garniture centrale", "Material da moldura central"], ["votre véhicule a t'il l'option line assist ? (volant vibrant) ou volant chauffant?", "O seu veículo tem a opção Line Assist? (volante vibratório) ou volante aquecido?"], ["ronde", "Redondo"], ["méplat", "Base plana"], ["sportive", "Desportivo"], ["personnaliser la garniture centrale ?", "Personalizar a moldura central?"]];
  var KF_PHRASE_MAP_PT = {};
  KF_PHRASE_MAP_PT_RAW.forEach(function (p) { KF_PHRASE_MAP_PT[kfNormKey(p[0])] = p[1]; });
  var KF_UI_STRINGS_PT = kfIsBrazilian() ? {"Valider la configuration": "Validar a configuração", "Ajouter au panier": "Adicionar ao carrinho", "Suivant": "Próximo", "Préparation de votre configuration…": "Preparando sua configuração…", "Ajout en cours…": "Adicionando…", "Erreur — réessayez": "Erro, tente novamente", "Merci de répondre avant de continuer.": "Responda antes de continuar.", "Configurateur bientôt disponible": "Configurador em breve disponível", "Choisir un fichier": "Escolher um arquivo", "En savoir plus": "Saber mais", "Chargement…": "Carregando…", "Impossible de charger le guide. ": "Não foi possível carregar o guia. ", "Ouvrir dans un nouvel onglet": "Abrir em uma nova guia", "Préparation du configurateur…": "Preparando o configurador…", "Fermer": "Fechar", "Question précédente": "Pergunta anterior", "(envoi…)": "(enviando…)", "Le configurateur n'affiche qu'un rendu en forme méplat. Si vous choisissez la forme ronde, votre volant sera bien fabriqué dans cette forme.": "O configurador só mostra uma visualização em forma de base plana. Se escolher a forma redonda, seu volante será fabricado nessa forma.", "Vous pouvez tout de même faire vos choix ci-dessous : nous vous enverrons un rendu de votre volant une fois la commande passée, ou dès maintenant si vous préférez :": "Pode, ainda assim, fazer suas escolhas abaixo: enviaremos uma visualização do seu volante depois de fazer o pedido ou já agora, se preferir:", "Recevoir un aperçu avant de commander": "Receber uma pré-visualização antes de fazer o pedido", "Recevoir ma maquette": "Receber minha maquete", "Choose an option": "Escolha uma opção", "Année + Modèle et Personnalisation": "Ano + Modelo e Personalização"} : {"Valider la configuration": "Validar a configuração", "Ajouter au panier": "Adicionar ao carrinho", "Suivant": "Seguinte", "Préparation de votre configuration…": "Preparação da sua configuração…", "Ajout en cours…": "A adicionar…", "Erreur — réessayez": "Erro, tente novamente", "Merci de répondre avant de continuer.": "Responda antes de continuar.", "Configurateur bientôt disponible": "Configurador em breve disponível", "Choisir un fichier": "Escolher um ficheiro", "En savoir plus": "Saber mais", "Chargement…": "A carregar…", "Impossible de charger le guide. ": "Não foi possível carregar o guia. ", "Ouvrir dans un nouvel onglet": "Abrir num novo separador", "Préparation du configurateur…": "Preparação do configurador…", "Fermer": "Fechar", "Question précédente": "Pergunta anterior", "(envoi…)": "(a enviar…)", "Le configurateur n'affiche qu'un rendu en forme méplat. Si vous choisissez la forme ronde, votre volant sera bien fabriqué dans cette forme.": "O configurador só mostra uma visualização em forma de base plana. Se escolher a forma redonda, o seu volante será fabricado nessa forma.", "Vous pouvez tout de même faire vos choix ci-dessous : nous vous enverrons un rendu de votre volant une fois la commande passée, ou dès maintenant si vous préférez :": "Pode, ainda assim, fazer as suas escolhas abaixo: enviaremos uma visualização do seu volante depois de fazer a encomenda ou já agora, se preferir:", "Recevoir un aperçu avant de commander": "Receber uma pré-visualização antes de encomendar", "Recevoir ma maquette": "Receber a minha maquete", "Choose an option": "Escolha uma opção", "Année + Modèle et Personnalisation": "Ano + Modelo e Personalização"};
  var KF_PT_MATERIALS = kfIsBrazilian() ? [["carbone noir nid d'abeilles", "carbono preto em favo de mel", "m"], ["nid d'abeilles", "favo de mel", "m"], ["carbone forgé", "carbono forjado", "m"], ["carbon forgé", "carbono forjado", "m"], ["carbone forge", "carbono forjado", "m"], ["carbone allégé", "carbono leve", "m"], ["carbone allege", "carbono leve", "m"], ["fibre sergée", "fibra twill", "f"], ["fibre sergé", "fibra twill", "f"], ["cuir perforé", "couro perfurado", "m"], ["cuir perfore", "couro perfurado", "m"], ["cuir lisse", "couro liso", "m"], ["cuir surpiqué", "couro com costuras", "m"], ["forgé", "forjado", "m"], ["forge", "forjado", "m"], ["carbone", "carbono", "m"], ["carbon", "carbono", "m"], ["caborne", "carbono", "m"], ["alcantara", "Alcantara", "f"], ["cuir", "couro", "m"], ["aluminium", "alumínio", "m"]] : [["carbone noir nid d'abeilles", "carbono preto em favo de mel", "m"], ["nid d'abeilles", "favo de mel", "m"], ["carbone forgé", "carbono forjado", "m"], ["carbon forgé", "carbono forjado", "m"], ["carbone forge", "carbono forjado", "m"], ["carbone allégé", "carbono leve", "m"], ["carbone allege", "carbono leve", "m"], ["fibre sergée", "fibra twill", "f"], ["fibre sergé", "fibra twill", "f"], ["cuir perforé", "pele perfurada", "f"], ["cuir perfore", "pele perfurada", "f"], ["cuir lisse", "pele lisa", "f"], ["cuir surpiqué", "pele com costuras", "f"], ["forgé", "forjado", "m"], ["forge", "forjado", "m"], ["carbone", "carbono", "m"], ["carbon", "carbono", "m"], ["caborne", "carbono", "m"], ["alcantara", "Alcantara", "f"], ["cuir", "pele", "f"], ["aluminium", "alumínio", "m"]];
  // [french, masculine, feminine]
  var KF_PT_COLORS = kfIsBrazilian() ? [["bleu ciel", "azul-celeste", "azul-celeste"], ["noir brillant", "preto brilhante", "preta brilhante"], ["noire brillante", "preta brilhante", "preta brilhante"], ["noir matte", "preto mate", "preta mate"], ["noir mat", "preto mate", "preta mate"], ["noire mat", "preta mate", "preta mate"], ["rouge mat", "vermelho mate", "vermelha mate"], ["argenté mat", "prateado mate", "prateada mate"], ["noire", "preta", "preta"], ["noir", "preto", "preta"], ["blanche", "branca", "branca"], ["blanc", "branco", "branca"], ["bleu", "azul", "azul"], ["rouge", "vermelho", "vermelha"], ["verte", "verde", "verde"], ["vert", "verde", "verde"], ["jaune", "amarelo", "amarela"], ["rose", "rosa", "rosa"], ["violet", "violeta", "violeta"], ["grise", "cinza", "cinza"], ["gris", "cinza", "cinza"], ["marron", "marrom", "marrom"], ["beige", "bege", "bege"], ["orange", "laranja", "laranja"], ["bordeaux", "bordô", "bordô"], ["argenté", "prateado", "prateada"], ["argent", "prateado", "prateada"], ["doré", "dourado", "dourada"], ["or", "dourado", "dourada"], ["matte", "mate", "mate"], ["mat", "mate", "mate"], ["brillant", "brilhante", "brilhante"]] : [["bleu ciel", "azul-celeste", "azul-celeste"], ["noir brillant", "preto brilhante", "preta brilhante"], ["noire brillante", "preta brilhante", "preta brilhante"], ["noir matte", "preto mate", "preta mate"], ["noir mat", "preto mate", "preta mate"], ["noire mat", "preta mate", "preta mate"], ["rouge mat", "vermelho mate", "vermelha mate"], ["argenté mat", "prateado mate", "prateada mate"], ["noire", "preta", "preta"], ["noir", "preto", "preta"], ["blanche", "branca", "branca"], ["blanc", "branco", "branca"], ["bleu", "azul", "azul"], ["rouge", "vermelho", "vermelha"], ["verte", "verde", "verde"], ["vert", "verde", "verde"], ["jaune", "amarelo", "amarela"], ["rose", "rosa", "rosa"], ["violet", "violeta", "violeta"], ["grise", "cinzenta", "cinzenta"], ["gris", "cinzento", "cinzenta"], ["marron", "castanho", "castanha"], ["beige", "bege", "bege"], ["orange", "laranja", "laranja"], ["bordeaux", "bordeaux", "bordeaux"], ["argenté", "prateado", "prateada"], ["argent", "prateado", "prateada"], ["doré", "dourado", "dourada"], ["or", "dourado", "dourada"], ["matte", "mate", "mate"], ["mat", "mate", "mate"], ["brillant", "brilhante", "brilhante"]];
  var KF_PT_MISC = {"oui": "Sim", "non": "Não", "avec": "Com", "sans": "Sem", "aucun": "Nenhum", "aucune": "Nenhuma", "et": "e", "allemagne": "Alemanha", "untitled answer": "Sem título", "volant chauffant": "Volante aquecido", "m performance": "M Performance", "s-line": "S-Line", "r-line": "R-Line", "line assist": "Line Assist"};
  function kfPtAnswer(text) {
    var t = text.trim().replace(/\s+/g, ' ').replace(/al+[eé]g[eé]e?/gi, 'allégé');
    if (!t) return null;
    var low = t.toLowerCase();
    if (KF_PT_MISC.hasOwnProperty(low)) return KF_PT_MISC[low];
    var upper = t.length > 1 && t === t.toUpperCase() && t !== t.toLowerCase();
    var rest = low, out = [], gender = null, changed = false;
    for (var i = 0; i < KF_PT_MATERIALS.length; i++) {
      var mat = KF_PT_MATERIALS[i];
      if (rest === mat[0] || rest.indexOf(mat[0] + ' ') === 0) {
        out.push(mat[1]); gender = mat[2]; rest = rest.slice(mat[0].length).trim(); changed = true; break;
      }
    }
    while (rest) {
      var hit = null;
      for (var j = 0; j < KF_PT_COLORS.length; j++) {
        var c = KF_PT_COLORS[j];
        if (rest === c[0] || rest.indexOf(c[0] + ' ') === 0) { hit = c; break; }
      }
      if (hit) {
        var fem = gender ? gender === 'f' : false;
        out.push(fem ? hit[2] : hit[1]); rest = rest.slice(hit[0].length).trim(); changed = true;
      } else {
        var sp = rest.indexOf(' ');
        var tok = sp === -1 ? rest : rest.slice(0, sp);
        var origTok = t.slice(t.length - rest.length, t.length - rest.length + tok.length);
        if (KF_PT_MISC.hasOwnProperty(tok)) { out.push(KF_PT_MISC[tok].toLowerCase()); changed = true; }
        else out.push(origTok);
        rest = sp === -1 ? '' : rest.slice(sp + 1).trim();
      }
    }
    if (!changed) return null;
    var res = out.join(' ');
    if (upper) return res.toUpperCase();
    return res.charAt(0).toUpperCase() + res.slice(1);
  }
  function kfTranslatePt(text) {
    var trimmed = text.trim().replace(/\s+/g, ' ');
    var key = kfNormKey(trimmed);
    if (KF_PHRASE_MAP_PT.hasOwnProperty(key)) return KF_PHRASE_MAP_PT[key];
    var res = kfPtAnswer(trimmed);
    return res === null ? trimmed : res;
  }
  // ---------------------------------------------------------------------

  // --- German layer (mirrors the Italian one; data stays French) --------
  var KF_PHRASE_MAP_DE_RAW = [
    ["forme du volant", "Form des Lenkrads"],
    ["type de poignées", "Art der Griffbereiche"],
    ["poignées en cuir perforé", "Griffbereiche aus perforiertem Leder"],
    ["poignées cuir perforé", "Griffbereiche aus perforiertem Leder"],
    ["poignées en cuir lisse", "Griffbereiche aus glattem Leder"],
    ["poignées cuir lisse", "Griffbereiche aus glattem Leder"],
    ["poignées en alcantara", "Griffbereiche aus Alcantara"],
    ["poignées alcantara", "Griffbereiche aus Alcantara"],
    ["type d'insert", "Art des Einsatzes"],
    ["insert en cuir lisse", "Einsatz aus glattem Leder"],
    ["insert cuir lisse", "Einsatz aus glattem Leder"],
    ["insert cuir", "Einsatz aus Leder"],
    ["insert en alcantara", "Einsatz aus Alcantara"],
    ["insert alcantara", "Einsatz aus Alcantara"],
    ["insert en carbone", "Einsatz aus Carbon"],
    ["insert carbone", "Einsatz aus Carbon"],
    ["insert en carbone forgé", "Einsatz aus Carbon Forgé"],
    ["insert carbone forgé", "Einsatz aus Carbon Forgé"],
    ["couleur des surpiqures (pas visible sur le configurateur)", "Farbe der Ziernähte (im Konfigurator nicht sichtbar)"],
    ["couleur des surpiqures", "Farbe der Ziernähte"],
    ["couleur des surpiqures du cache airbag", "Farbe der Ziernähte der Airbagabdeckung"],
    ["rappel 12h", "12-Uhr-Markierung"],
    ["personnaliser le cache airbag ?", "Airbagabdeckung personalisieren?"],
    ["matière cache airbag", "Material der Airbagabdeckung"],
    ["couleur du logo", "Logofarbe"],
    ["shiftled", "ShiftLed"],
    ["boîte automatique?", "Automatikgetriebe?"],
    ["palettes txcp", "TXCP-Schaltwippen"],
    ["couleur palettes carbone", "Farbe der Carbon-Schaltwippen"],
    ["couleur palettes carbone allegee", "Farbe der Schaltwippen aus Leichtbau-Carbon"],
    ["couleur palettes allegee", "Farbe der Schaltwippen aus Leichtbau-Carbon"],
    ["couleur palettes carbone forgé", "Farbe der Schaltwippen aus Carbon Forgé"],
    ["avez-vous l'option volant chauffant?", "Hat Ihr Fahrzeug die Option Lenkradheizung?"],
    ["ajout du pack volant complet (commande au volant, électronique de palette, airbag complet)", "Hinzufügen des kompletten Lenkradpakets (Lenkradbedienung, Schaltwippen-Elektronik, komplettes Airbagmodul)"],
    ["ajout du pack volant complet (électronique de palette, airbag complet)", "Hinzufügen des kompletten Lenkradpakets (Schaltwippen-Elektronik, komplettes Airbagmodul)"],
    ["modèle du véhicule et indiquez vos préférences de configuration (surpiqûres, couleur du rappel 12:00, style de carbone,etc.). nous en tiendrons compte lors de la fabrication.", "Fahrzeugmodell und geben Sie Ihre Konfigurationswünsche an (Ziernähte, Farbe der 12-Uhr-Markierung, Carbon-Stil usw.). Wir berücksichtigen dies bei der Fertigung."],
    ["envoyez une photo de votre volant actuel", "Senden Sie ein Foto Ihres aktuellen Lenkrads"],
    ["personnaliser le contour des boutons ?", "Tastenkontur personalisieren?"],
    ["contours des boutons", "Tastenkonturen"],
    ["logo", "Logo"],
    ["couleur des lettres du logo", "Farbe der Logo-Buchstaben"],
    ["couleur logo", "Logofarbe"],
    ["bouton style r8", "Taste im R8-Stil"],
    ["logo insert", "Einsatz mit Logo"],
    ["garniture supplémentaire", "Zusätzliche Zierleiste"],
    ["garnitures supplémentaires", "Zusätzliche Zierleisten"],
    ["coutures cache airbag", "Nähte der Airbagabdeckung"],
    ["personnaliser la garniture centrale", "Mittlere Zierleiste personalisieren?"],
    ["personnaliser la garniture centrale ?", "Mittlere Zierleiste personalisieren?"],
    ["personnaliser les garnitures ?", "Zierleisten personalisieren?"],
    ["couleur garnitures", "Farbe der Zierleisten"],
    ["matière garniture centrale", "Material der mittleren Zierleiste"],
    ["votre véhicule a t'il l'option line assist ? (volant vibrant) ou volant chauffant?", "Hat Ihr Fahrzeug die Option Line Assist? (vibrierendes Lenkrad) oder Lenkradheizung?"],
    ["ronde", "Rund"],
    ["méplat", "Flachboden"],
    ["sportive", "Sportlich"]
  ];
  var KF_PHRASE_MAP_DE = {};
  KF_PHRASE_MAP_DE_RAW.forEach(function (p) { KF_PHRASE_MAP_DE[kfNormKey(p[0])] = p[1]; });
  var KF_UI_STRINGS_DE = {
    "Valider la configuration": "Konfiguration bestätigen",
    "Ajouter au panier": "In den Warenkorb legen",
    "Suivant": "Weiter",
    "Préparation de votre configuration…": "Ihre Konfiguration wird vorbereitet…",
    "Ajout en cours…": "Wird hinzugefügt…",
    "Erreur — réessayez": "Fehler, bitte erneut versuchen",
    "Merci de répondre avant de continuer.": "Bitte antworten Sie, bevor Sie fortfahren.",
    "Configurateur bientôt disponible": "Konfigurator bald verfügbar",
    "Choisir un fichier": "Datei auswählen",
    "En savoir plus": "Mehr erfahren",
    "Chargement…": "Wird geladen…",
    "Impossible de charger le guide. ": "Der Leitfaden konnte nicht geladen werden. ",
    "Ouvrir dans un nouvel onglet": "In neuem Tab öffnen",
    "Préparation du configurateur…": "Konfigurator wird vorbereitet…",
    "Fermer": "Schließen",
    "Question précédente": "Vorherige Frage",
    "(envoi…)": "(wird gesendet…)",
    "Le configurateur n'affiche qu'un rendu en forme méplat. Si vous choisissez la forme ronde, votre volant sera bien fabriqué dans cette forme.": "Der Konfigurator zeigt nur eine Vorschau in der Flachboden-Form. Wenn Sie die runde Form wählen, wird Ihr Lenkrad trotzdem in dieser Form gefertigt.",
    "Vous pouvez tout de même faire vos choix ci-dessous : nous vous enverrons un rendu de votre volant une fois la commande passée, ou dès maintenant si vous préférez :": "Sie können Ihre Auswahl trotzdem unten treffen: Wir senden Ihnen eine Vorschau Ihres Lenkrads, sobald die Bestellung aufgegeben ist, oder sofort, wenn Sie das bevorzugen:",
    "Recevoir un aperçu avant de commander": "Vorschau vor der Bestellung erhalten",
    "Recevoir ma maquette": "Meine Vorschau erhalten",
    "Choose an option": "Option wählen",
    "Année + Modèle et Personnalisation": "Jahr + Modell und Personalisierung"
  };

  var KF_DE_MATERIALS = [
    ["carbone noir nid d'abeilles", "Carbon mit Wabenstruktur"], ["nid d'abeilles", "Wabenstruktur"],
    ["carbone forgé", "Carbon Forgé"], ["carbon forgé", "Carbon Forgé"], ["carbone forge", "Carbon Forgé"],
    ["carbone allégé", "Leichtbau-Carbon"], ["carbone allege", "Leichtbau-Carbon"],
    ["fibre sergée", "Köperfaser"], ["fibre sergé", "Köperfaser"],
    ["cuir perforé", "perforiertes Leder"], ["cuir perfore", "perforiertes Leder"], ["cuir lisse", "glattes Leder"], ["cuir surpiqué", "Leder mit Ziernähten"],
    ["forgé", "Forgé"], ["forge", "Forgé"],
    ["carbone", "Carbon"], ["carbon", "Carbon"], ["caborne", "Carbon"],
    ["alcantara", "Alcantara"], ["cuir", "Leder"], ["aluminium", "Aluminium"]
  ];
  var KF_DE_COLORS = [
    ["bleu ciel", "Himmelblau"], ["noir brillant", "Glänzend Schwarz"], ["noire brillante", "Glänzend Schwarz"],
    ["noir matte", "Matt Schwarz"], ["noir mat", "Matt Schwarz"], ["noire mat", "Matt Schwarz"],
    ["rouge mat", "Matt Rot"], ["argenté mat", "Matt Silber"],
    ["noire", "Schwarz"], ["noir", "Schwarz"], ["blanche", "Weiß"], ["blanc", "Weiß"],
    ["bleu", "Blau"], ["rouge", "Rot"], ["verte", "Grün"], ["vert", "Grün"],
    ["jaune", "Gelb"], ["rose", "Rosa"], ["violet", "Violett"], ["grise", "Grau"], ["gris", "Grau"],
    ["marron", "Braun"], ["beige", "Beige"], ["orange", "Orange"], ["bordeaux", "Bordeaux"],
    ["argenté", "Silber"], ["argent", "Silber"], ["doré", "Gold"], ["or", "Gold"],
    ["matte", "Matt"], ["mat", "Matt"], ["brillant", "Glänzend"]
  ];
  var KF_DE_MISC = {
    'oui': 'Ja', 'non': 'Nein', 'avec': 'Mit', 'sans': 'Ohne', 'aucun': 'Keine', 'aucune': 'Keine',
    'allemagne': 'Deutschland', 'untitled answer': 'Ohne Titel', 'volant chauffant': 'Lenkradheizung', 'm performance': 'M Performance'
  };
  function kfDeAnswer(text) {
    var t = text.trim().replace(/\s+/g, ' ').replace(/al+[eé]g[eé]e?/gi, 'allégé');
    if (!t) return null;
    var low = t.toLowerCase();
    if (KF_DE_MISC.hasOwnProperty(low)) return KF_DE_MISC[low];
    var upper = t.length > 1 && t === t.toUpperCase() && t !== t.toLowerCase();
    var rest = low, out = [], changed = false;
    for (var i = 0; i < KF_DE_MATERIALS.length; i++) {
      var mat = KF_DE_MATERIALS[i];
      if (rest === mat[0] || rest.indexOf(mat[0] + ' ') === 0) {
        out.push(mat[1]); rest = rest.slice(mat[0].length).trim(); changed = true; break;
      }
    }
    while (rest) {
      var hit = null;
      for (var j = 0; j < KF_DE_COLORS.length; j++) {
        var c = KF_DE_COLORS[j];
        if (rest === c[0] || rest.indexOf(c[0] + ' ') === 0) { hit = c; break; }
      }
      if (hit) {
        out.push(hit[1]); rest = rest.slice(hit[0].length).trim(); changed = true;
      } else {
        var sp = rest.indexOf(' ');
        var tok = sp === -1 ? rest : rest.slice(0, sp);
        var origTok = t.slice(t.length - rest.length, t.length - rest.length + tok.length);
        out.push(origTok); rest = sp === -1 ? '' : rest.slice(sp + 1).trim();
      }
    }
    if (!changed) return null;
    var res = out.join(' ');
    if (upper) return res.toUpperCase();
    return res.charAt(0).toUpperCase() + res.slice(1);
  }
  function kfTranslateDe(text) {
    var trimmed = text.trim().replace(/\s+/g, ' ');
    var key = kfNormKey(trimmed);
    if (KF_PHRASE_MAP_DE.hasOwnProperty(key)) return KF_PHRASE_MAP_DE[key];
    var res = kfDeAnswer(trimmed);
    return res === null ? trimmed : res;
  }
  // ---------------------------------------------------------------------

  // --- Dutch layer (mirrors the German one; data stays French) ----------
  var KF_PHRASE_MAP_NL_RAW = [
    ["forme du volant", "Vorm van het stuurwiel"],
    ["type de poignées", "Type handgrepen"],
    ["poignées en cuir perforé", "Handgrepen van geperforeerd leer"],
    ["poignées cuir perforé", "Handgrepen van geperforeerd leer"],
    ["poignées en cuir lisse", "Handgrepen van glad leer"],
    ["poignées cuir lisse", "Handgrepen van glad leer"],
    ["poignées en alcantara", "Handgrepen van Alcantara"],
    ["poignées alcantara", "Handgrepen van Alcantara"],
    ["type d'insert", "Type insert"],
    ["insert en cuir lisse", "Insert van glad leer"],
    ["insert cuir lisse", "Insert van glad leer"],
    ["insert cuir", "Insert van leer"],
    ["insert en alcantara", "Insert van Alcantara"],
    ["insert alcantara", "Insert van Alcantara"],
    ["insert en carbone", "Insert van carbon"],
    ["insert carbone", "Insert van carbon"],
    ["insert en carbone forgé", "Insert van forged carbon"],
    ["insert carbone forgé", "Insert van forged carbon"],
    ["couleur des surpiqures (pas visible sur le configurateur)", "Kleur van de stiksels (niet zichtbaar in de configurator)"],
    ["couleur des surpiqures", "Kleur van de stiksels"],
    ["couleur des surpiqures du cache airbag", "Kleur van de stiksels van de airbagafdekking"],
    ["rappel 12h", "12-uurmarkering"],
    ["personnaliser le cache airbag ?", "Airbagafdekking personaliseren?"],
    ["matière cache airbag", "Materiaal van de airbagafdekking"],
    ["couleur du logo", "Kleur van het logo"],
    ["shiftled", "ShiftLed"],
    ["boîte automatique?", "Automatische versnellingsbak?"],
    ["palettes txcp", "TXCP-paddels"],
    ["couleur palettes carbone", "Kleur van de carbon paddels"],
    ["couleur palettes carbone allegee", "Kleur van de paddels van lichtgewicht carbon"],
    ["couleur palettes allegee", "Kleur van de paddels van lichtgewicht carbon"],
    ["couleur palettes carbone forgé", "Kleur van de paddels van forged carbon"],
    ["avez-vous l'option volant chauffant?", "Heeft je voertuig de optie stuurwielverwarming?"],
    ["ajout du pack volant complet (commande au volant, électronique de palette, airbag complet)", "Toevoeging van het complete stuurwielpakket (stuurwielbediening, paddelelektronica, complete airbag)"],
    ["ajout du pack volant complet (électronique de palette, airbag complet)", "Toevoeging van het complete stuurwielpakket (paddelelektronica, complete airbag)"],
    ["modèle du véhicule et indiquez vos préférences de configuration (surpiqûres, couleur du rappel 12:00, style de carbone,etc.). nous en tiendrons compte lors de la fabrication.", "Voertuigmodel en geef je configuratievoorkeuren aan (stiksels, kleur van de 12-uurmarkering, carbonstijl enzovoort). Wij houden hier bij de productie rekening mee."],
    ["envoyez une photo de votre volant actuel", "Stuur een foto van je huidige stuurwiel"],
    ["personnaliser le contour des boutons ?", "Knopcontour personaliseren?"],
    ["contours des boutons", "Knopcontouren"],
    ["logo", "Logo"],
    ["couleur des lettres du logo", "Kleur van de letters van het logo"],
    ["couleur logo", "Kleur van het logo"],
    ["bouton style r8", "Knop in R8-stijl"],
    ["logo insert", "Insert met logo"],
    ["garniture supplémentaire", "Extra sierlijst"],
    ["garnitures supplémentaires", "Extra sierlijsten"],
    ["coutures cache airbag", "Stiksels van de airbagafdekking"],
    ["personnaliser la garniture centrale", "Middelste sierlijst personaliseren?"],
    ["personnaliser la garniture centrale ?", "Middelste sierlijst personaliseren?"],
    ["personnaliser les garnitures ?", "Sierlijsten personaliseren?"],
    ["couleur garnitures", "Kleur van de sierlijsten"],
    ["matière garniture centrale", "Materiaal van de middelste sierlijst"],
    ["votre véhicule a t'il l'option line assist ? (volant vibrant) ou volant chauffant?", "Heeft je voertuig de optie Line Assist? (trillend stuurwiel) of stuurwielverwarming?"],
    ["ronde", "Rond"],
    ["méplat", "Platte onderkant"],
    ["sportive", "Sportief"]
  ];
  var KF_PHRASE_MAP_NL = {};
  KF_PHRASE_MAP_NL_RAW.forEach(function (p) { KF_PHRASE_MAP_NL[kfNormKey(p[0])] = p[1]; });
  var KF_UI_STRINGS_NL = {
    "Valider la configuration": "Configuratie bevestigen",
    "Ajouter au panier": "In winkelwagen",
    "Suivant": "Volgende",
    "Préparation de votre configuration…": "Je configuratie wordt voorbereid…",
    "Ajout en cours…": "Wordt toegevoegd…",
    "Erreur — réessayez": "Fout, probeer het opnieuw",
    "Merci de répondre avant de continuer.": "Beantwoord de vraag voordat je verdergaat.",
    "Configurateur bientôt disponible": "Configurator binnenkort beschikbaar",
    "Choisir un fichier": "Bestand kiezen",
    "En savoir plus": "Meer informatie",
    "Chargement…": "Laden…",
    "Impossible de charger le guide. ": "De gids kon niet worden geladen. ",
    "Ouvrir dans un nouvel onglet": "Openen in een nieuw tabblad",
    "Préparation du configurateur…": "Configurator wordt voorbereid…",
    "Fermer": "Sluiten",
    "Question précédente": "Vorige vraag",
    "(envoi…)": "(wordt verzonden…)",
    "Le configurateur n'affiche qu'un rendu en forme méplat. Si vous choisissez la forme ronde, votre volant sera bien fabriqué dans cette forme.": "De configurator toont alleen een voorbeeld met platte onderkant. Als je de ronde vorm kiest, wordt je stuurwiel wel in die vorm gemaakt.",
    "Vous pouvez tout de même faire vos choix ci-dessous : nous vous enverrons un rendu de votre volant une fois la commande passée, ou dès maintenant si vous préférez :": "Je kunt hieronder toch gewoon je keuzes maken: we sturen je een voorbeeld van je stuurwiel zodra je bestelling is geplaatst, of nu meteen als je dat liever hebt:",
    "Recevoir un aperçu avant de commander": "Een voorbeeld ontvangen vóór het bestellen",
    "Recevoir ma maquette": "Mijn voorbeeld ontvangen",
    "Choose an option": "Kies een optie",
    "Année + Modèle et Personnalisation": "Jaar + Model en personalisatie"
  };
  var KF_NL_MATERIALS = [
    ["carbone noir nid d'abeilles", "carbon met honingraatstructuur"], ["nid d'abeilles", "honingraatstructuur"], ["carbone forgé", "forged carbon"], ["carbon forgé", "forged carbon"], ["carbone forge", "forged carbon"], ["carbone allégé", "lichtgewicht carbon"], ["carbone allege", "lichtgewicht carbon"], ["fibre sergée", "twill carbon"], ["fibre sergé", "twill carbon"], ["cuir perforé", "geperforeerd leer"], ["cuir perfore", "geperforeerd leer"], ["cuir lisse", "glad leer"], ["cuir surpiqué", "leer met stiksels"], ["forgé", "forged"], ["forge", "forged"], ["carbone", "carbon"], ["carbon", "carbon"], ["caborne", "carbon"], ["alcantara", "Alcantara"], ["cuir", "leer"], ["aluminium", "aluminium"]
  ];
  var KF_NL_COLORS = [
    ["bleu ciel", "hemelsblauw"], ["noir brillant", "glanzend zwart"], ["noire brillante", "glanzend zwart"], ["noir matte", "mat zwart"], ["noir mat", "mat zwart"], ["noire mat", "mat zwart"], ["rouge mat", "mat rood"], ["argenté mat", "mat zilver"], ["noire", "zwart"], ["noir", "zwart"], ["blanche", "wit"], ["blanc", "wit"], ["bleu", "blauw"], ["rouge", "rood"], ["verte", "groen"], ["vert", "groen"], ["jaune", "geel"], ["rose", "roze"], ["violet", "paars"], ["grise", "grijs"], ["gris", "grijs"], ["marron", "bruin"], ["beige", "beige"], ["orange", "oranje"], ["bordeaux", "bordeaux"], ["argenté", "zilver"], ["argent", "zilver"], ["doré", "goud"], ["or", "goud"], ["matte", "mat"], ["mat", "mat"], ["brillant", "glanzend"]
  ];
  var KF_NL_MISC = {
    "oui": "Ja", "non": "Nee", "avec": "Met", "sans": "Zonder", "aucun": "Geen", "aucune": "Geen", "allemagne": "Duitsland", "untitled answer": "Zonder titel", "volant chauffant": "Stuurwielverwarming", "m performance": "M Performance"
  };
  function kfNlAnswer(text) {
    var t = text.trim().replace(/\s+/g, ' ').replace(/al+[eé]g[eé]e?/gi, 'allégé');
    if (!t) return null;
    var low = t.toLowerCase();
    if (KF_NL_MISC.hasOwnProperty(low)) return KF_NL_MISC[low];
    var upper = t.length > 1 && t === t.toUpperCase() && t !== t.toLowerCase();
    var rest = low, out = [], changed = false;
    for (var i = 0; i < KF_NL_MATERIALS.length; i++) {
      var mat = KF_NL_MATERIALS[i];
      if (rest === mat[0] || rest.indexOf(mat[0] + ' ') === 0) {
        out.push(mat[1]); rest = rest.slice(mat[0].length).trim(); changed = true; break;
      }
    }
    while (rest) {
      var hit = null;
      for (var j = 0; j < KF_NL_COLORS.length; j++) {
        var c = KF_NL_COLORS[j];
        if (rest === c[0] || rest.indexOf(c[0] + ' ') === 0) { hit = c; break; }
      }
      if (hit) {
        out.push(hit[1]); rest = rest.slice(hit[0].length).trim(); changed = true;
      } else {
        var sp = rest.indexOf(' ');
        var tok = sp === -1 ? rest : rest.slice(0, sp);
        var origTok = t.slice(t.length - rest.length, t.length - rest.length + tok.length);
        out.push(origTok); rest = sp === -1 ? '' : rest.slice(sp + 1).trim();
      }
    }
    if (!changed) return null;
    var res = out.join(' ');
    if (upper) return res.toUpperCase();
    return res.charAt(0).toUpperCase() + res.slice(1);
  }
  function kfTranslateNl(text) {
    var trimmed = text.trim().replace(/\s+/g, ' ');
    var key = kfNormKey(trimmed);
    if (KF_PHRASE_MAP_NL.hasOwnProperty(key)) return KF_PHRASE_MAP_NL[key];
    var res = kfNlAnswer(trimmed);
    return res === null ? trimmed : res;
  }
  // ---------------------------------------------------------------------

  // --- English layer (mirrors the German one; data stays French) --------
  var KF_PHRASE_MAP_EN_RAW = [
    ["forme du volant", "Steering Wheel Shape"],
    ["type de poignées", "Grip Type"],
    ["poignées en cuir perforé", "Perforated Leather Grips"],
    ["poignées cuir perforé", "Perforated Leather Grips"],
    ["poignées en cuir lisse", "Smooth Leather Grips"],
    ["poignées cuir lisse", "Smooth Leather Grips"],
    ["poignées en alcantara", "Alcantara Grips"],
    ["poignées alcantara", "Alcantara Grips"],
    ["type d'insert", "Insert Type"],
    ["insert en cuir lisse", "Smooth Leather Insert"],
    ["insert cuir lisse", "Smooth Leather Insert"],
    ["insert cuir", "Leather Insert"],
    ["insert en alcantara", "Alcantara Insert"],
    ["insert alcantara", "Alcantara Insert"],
    ["insert en carbone", "Carbon Insert"],
    ["insert carbone", "Carbon Insert"],
    ["insert en carbone forgé", "Forged Carbon Insert"],
    ["insert carbone forgé", "Forged Carbon Insert"],
    ["couleur des surpiqures (pas visible sur le configurateur)", "Stitching Color (not shown in configurator)"],
    ["couleur des surpiqures", "Stitching Color"],
    ["couleur des surpiqures du cache airbag", "Airbag Cover Stitching Color"],
    ["rappel 12h", "12 O'Clock Marker"],
    ["personnaliser le cache airbag ?", "Customize the airbag cover?"],
    ["matière cache airbag", "Airbag Cover Material"],
    ["couleur du logo", "Logo Color"],
    ["shiftled", "ShiftLed"],
    ["boîte automatique?", "Automatic Transmission?"],
    ["palettes txcp", "TXCP Paddles"],
    ["couleur palettes carbone", "Carbon Paddle Color"],
    ["couleur palettes carbone allegee", "Lightweight Carbon Paddle Color"],
    ["couleur palettes allegee", "Lightweight Carbon Paddle Color"],
    ["couleur palettes carbone forgé", "Forged Carbon Paddle Color"],
    ["avez-vous l'option volant chauffant?", "Does your car have the Heated Steering Wheel option?"],
    ["ajout du pack volant complet (commande au volant, électronique de palette, airbag complet)", "Add the Full Steering Wheel Pack (steering wheel controls, paddle electronics, complete airbag)"],
    ["ajout du pack volant complet (électronique de palette, airbag complet)", "Add the Full Steering Wheel Pack (paddle electronics, complete airbag)"],
    ["modèle du véhicule et indiquez vos préférences de configuration (surpiqûres, couleur du rappel 12:00, style de carbone,etc.). nous en tiendrons compte lors de la fabrication.", "Vehicle model and your configuration preferences (stitching, 12 o'clock marker color, carbon style, etc.). We will take this into account during manufacturing."],
    ["envoyez une photo de votre volant actuel", "Send a photo of your current steering wheel"],
    ["personnaliser le contour des boutons ?", "Customize the button trim?"],
    ["contours des boutons", "Button Trim"],
    ["logo", "Logo"],
    ["couleur des lettres du logo", "Logo Letters Color"],
    ["couleur logo", "Logo Color"],
    ["bouton style r8", "R8-Style Button"],
    ["logo insert", "Logo Insert"],
    ["garniture supplémentaire", "Additional Trim"],
    ["garnitures supplémentaires", "Additional Trims"],
    ["coutures cache airbag", "Airbag Cover Stitching"],
    ["personnaliser la garniture centrale", "Customize the center trim?"],
    ["personnaliser la garniture centrale ?", "Customize the center trim?"],
    ["personnaliser les garnitures ?", "Customize the trims?"],
    ["couleur garnitures", "Trim Color"],
    ["matière garniture centrale", "Center Trim Material"],
    ["votre véhicule a t'il l'option line assist ? (volant vibrant) ou volant chauffant?", "Does your car have the Line Assist option (vibrating wheel) or Heated Steering Wheel?"],
    ["ronde", "Round"],
    ["méplat", "Flat-Bottom"],
    ["sportive", "Sport"]
  ];
  var KF_PHRASE_MAP_EN = {};
  KF_PHRASE_MAP_EN_RAW.forEach(function (p) { KF_PHRASE_MAP_EN[kfNormKey(p[0])] = p[1]; });

  var KF_EN_MATERIALS = [
    ["carbone noir nid d'abeilles", "Black Honeycomb Carbon"], ["nid d'abeilles", "Honeycomb"],
    ["carbone forgé", "Forged Carbon"], ["carbon forgé", "Forged Carbon"], ["carbone forge", "Forged Carbon"],
    ["carbone allégé", "Lightweight Carbon"], ["carbone allege", "Lightweight Carbon"],
    ["fibre sergée", "Twill Carbon"], ["fibre sergé", "Twill Carbon"],
    ["cuir perforé", "Perforated Leather"], ["cuir perfore", "Perforated Leather"], ["cuir lisse", "Smooth Leather"], ["cuir surpiqué", "Stitched Leather"],
    ["forgé", "Forged"], ["forge", "Forged"],
    ["carbone", "Carbon"], ["carbon", "Carbon"], ["caborne", "Carbon"],
    ["alcantara", "Alcantara"], ["cuir", "Leather"], ["aluminium", "Aluminum"]
  ];
  var KF_EN_COLORS = [
    ["bleu ciel", "Sky Blue"], ["noir brillant", "Gloss Black"], ["noire brillante", "Gloss Black"],
    ["noir matte", "Matte Black"], ["noir mat", "Matte Black"], ["noire mat", "Matte Black"],
    ["rouge mat", "Matte Red"], ["argenté mat", "Matte Silver"],
    ["noire", "Black"], ["noir", "Black"], ["blanche", "White"], ["blanc", "White"],
    ["bleu", "Blue"], ["rouge", "Red"], ["verte", "Green"], ["vert", "Green"],
    ["jaune", "Yellow"], ["rose", "Pink"], ["violet", "Purple"], ["grise", "Gray"], ["gris", "Gray"],
    ["marron", "Brown"], ["beige", "Beige"], ["orange", "Orange"], ["bordeaux", "Burgundy"],
    ["argenté", "Silver"], ["argent", "Silver"], ["doré", "Gold"], ["or", "Gold"],
    ["matte", "Matte"], ["mat", "Matte"], ["brillant", "Glossy"]
  ];
  var KF_EN_MISC = {
    'oui': 'Yes', 'non': 'No', 'avec': 'With', 'sans': 'Without', 'aucun': 'None', 'aucune': 'None',
    'allemagne': 'Germany', 'untitled answer': 'Untitled answer', 'volant chauffant': 'Heated Steering Wheel', 'm performance': 'M Performance',
    's-line': 'S-Line', 'r-line': 'R-Line', 'line assist': 'Line Assist',
    's-line noir': 'S-Line Black', 'r32 noir': 'R32 Black', 'gti noir': 'GTI Black', 'gti rouge': 'GTI Red', 'rs noir': 'RS Black', 's noir': 'S Black'
  };
  function kfEnAnswer(text) {
    var t = text.trim().replace(/\s+/g, ' ').replace(/al+[eé]g[eé]e?/gi, 'allégé');
    if (!t) return null;
    var low = t.toLowerCase();
    if (KF_EN_MISC.hasOwnProperty(low)) return KF_EN_MISC[low];
    // Connectors ("noir et rouge", "avec ...") keep their order: leave them to the caller's word-by-word fallback.
    if (/(^| )(et|avec|sans)( |$)/.test(low)) return null;
    var upper = t.length > 1 && t === t.toUpperCase() && t !== t.toLowerCase();
    var rest = low, mat = null, cols = [], others = [], changed = false;
    for (var i = 0; i < KF_EN_MATERIALS.length; i++) {
      var m = KF_EN_MATERIALS[i];
      if (rest === m[0] || rest.indexOf(m[0] + ' ') === 0) {
        mat = m[1]; rest = rest.slice(m[0].length).trim(); changed = true; break;
      }
    }
    while (rest) {
      var hit = null;
      for (var j = 0; j < KF_EN_COLORS.length; j++) {
        var c = KF_EN_COLORS[j];
        if (rest === c[0] || rest.indexOf(c[0] + ' ') === 0) { hit = c; break; }
      }
      if (hit) {
        cols.push(hit[1]); rest = rest.slice(hit[0].length).trim(); changed = true;
      } else {
        var sp = rest.indexOf(' ');
        var tok = sp === -1 ? rest : rest.slice(0, sp);
        others.push(t.slice(t.length - rest.length, t.length - rest.length + tok.length));
        rest = sp === -1 ? '' : rest.slice(sp + 1).trim();
      }
    }
    if (!changed) return null;
    var res = cols.concat(mat ? [mat] : [], others).join(' ');
    if (upper) return res.toUpperCase();
    return res.charAt(0).toUpperCase() + res.slice(1);
  }
  // ---------------------------------------------------------------------

  // --- Hebrew layer (same architecture as the German/English ones; data stays French) ---
  var KF_PHRASE_MAP_HE_RAW = [
    ["forme du volant", "צורת ההגה"],
    ["type de poignées", "סוג האחיזה"],
    ["poignées en cuir perforé", "אחיזה מעור מחורר"],
    ["poignées cuir perforé", "אחיזה מעור מחורר"],
    ["poignées en cuir lisse", "אחיזה מעור חלק"],
    ["poignées cuir lisse", "אחיזה מעור חלק"],
    ["poignées en alcantara", "אחיזה מאלקנטרה"],
    ["poignées alcantara", "אחיזה מאלקנטרה"],
    ["type d'insert", "סוג האינסרט"],
    ["insert en cuir lisse", "אינסרט מעור חלק"],
    ["insert cuir lisse", "אינסרט מעור חלק"],
    ["insert cuir", "אינסרט מעור"],
    ["insert en alcantara", "אינסרט מאלקנטרה"],
    ["insert alcantara", "אינסרט מאלקנטרה"],
    ["insert en carbone", "אינסרט מקרבון"],
    ["insert carbone", "אינסרט מקרבון"],
    ["insert en carbone forgé", "אינסרט מקרבון פורג'ד"],
    ["insert carbone forgé", "אינסרט מקרבון פורג'ד"],
    ["couleur des surpiqures (pas visible sur le configurateur)", "צבע התפרים (לא מוצג בקונפיגורטור)"],
    ["couleur des surpiqures", "צבע התפרים"],
    ["couleur des surpiqures du cache airbag", "צבע התפרים של כיסוי כרית האוויר"],
    ["rappel 12h", "סימון שעה 12"],
    ["personnaliser le cache airbag ?", "להתאים אישית את כיסוי כרית האוויר?"],
    ["matière cache airbag", "חומר כיסוי כרית האוויר"],
    ["couleur du logo", "צבע הלוגו"],
    ["shiftled", "ShiftLed"],
    ["boîte automatique?", "תיבה אוטומטית?"],
    ["palettes txcp", "פדלי TXCP"],
    ["couleur palettes carbone", "צבע פדלי הקרבון"],
    ["couleur palettes carbone allegee", "צבע פדלי הקרבון הקל"],
    ["couleur palettes allegee", "צבע פדלי הקרבון הקל"],
    ["couleur palettes carbone forgé", "צבע פדלי הקרבון הפורג'ד"],
    ["avez-vous l'option volant chauffant?", "האם ברכב שלכם יש את אפשרות ההגה המחומם?"],
    ["ajout du pack volant complet (commande au volant, électronique de palette, airbag complet)", "הוספת חבילת ההגה המלאה (כפתורי הגה, אלקטרוניקת פדלים, כרית אוויר מלאה)"],
    ["ajout du pack volant complet (électronique de palette, airbag complet)", "הוספת חבילת ההגה המלאה (אלקטרוניקת פדלים, כרית אוויר מלאה)"],
    ["modèle du véhicule et indiquez vos préférences de configuration (surpiqûres, couleur du rappel 12:00, style de carbone,etc.). nous en tiendrons compte lors de la fabrication.", "דגם הרכב וציינו את העדפות התצורה שלכם (תפרים, צבע סימון השעה 12, סגנון הקרבון וכו'). ניקח זאת בחשבון במהלך הייצור."],
    ["envoyez une photo de votre volant actuel", "שלחו תמונה של ההגה הנוכחי שלכם"],
    ["personnaliser le contour des boutons ?", "להתאים אישית את מסגרת הכפתורים?"],
    ["contours des boutons", "מסגרת הכפתורים"],
    ["logo", "לוגו"],
    ["couleur des lettres du logo", "צבע אותיות הלוגו"],
    ["couleur logo", "צבע הלוגו"],
    ["bouton style r8", "כפתור בסגנון R8"],
    ["logo insert", "לוגו האינסרט"],
    ["garniture supplémentaire", "חיפוי נוסף"],
    ["garnitures supplémentaires", "חיפויים נוספים"],
    ["coutures cache airbag", "תפרי כיסוי כרית האוויר"],
    ["personnaliser la garniture centrale", "להתאים אישית את החיפוי המרכזי?"],
    ["personnaliser les garnitures ?", "להתאים אישית את החיפויים?"],
    ["couleur garnitures", "צבע החיפויים"],
    ["matière garniture centrale", "חומר החיפוי המרכזי"],
    ["votre véhicule a t'il l'option line assist ? (volant vibrant) ou volant chauffant?", "האם ברכב שלכם יש את אפשרות Line Assist (הגה רוטט) או הגה מחומם?"],
    ["ronde", "עגולה"],
    ["méplat", "תחתית שטוחה"],
    ["sportive", "ספורטיבית"]
  ];
  var KF_PHRASE_MAP_HE = {};
  KF_PHRASE_MAP_HE_RAW.forEach(function (p) { KF_PHRASE_MAP_HE[kfNormKey(p[0])] = p[1]; });
  var KF_UI_STRINGS_HE = {
    "Valider la configuration": "אישור התצורה",
    "Ajouter au panier": "הוספה לעגלה",
    "Suivant": "הבא",
    "Préparation de votre configuration…": "מכינים את התצורה שלכם…",
    "Ajout en cours…": "מוסיפים…",
    "Erreur — réessayez": "שגיאה, נסו שוב",
    "Merci de répondre avant de continuer.": "אנא ענו לפני שממשיכים.",
    "Configurateur bientôt disponible": "הקונפיגורטור יהיה זמין בקרוב",
    "Choisir un fichier": "בחרו קובץ",
    "En savoir plus": "למידע נוסף",
    "Chargement…": "טוען…",
    "Impossible de charger le guide. ": "לא ניתן לטעון את המדריך. ",
    "Ouvrir dans un nouvel onglet": "פתיחה בלשונית חדשה",
    "Préparation du configurateur…": "מכינים את הקונפיגורטור…",
    "Fermer": "סגירה",
    "Question précédente": "השאלה הקודמת",
    "(envoi…)": "(מעלה…)",
    "Le configurateur n'affiche qu'un rendu en forme méplat. Si vous choisissez la forme ronde, votre volant sera bien fabriqué dans cette forme.": "הקונפיגורטור מציג רק תצוגה מקדימה של תחתית שטוחה. אם תבחרו בצורה העגולה, ההגה שלכם עדיין ייוצר בצורה זו.",
    "Vous pouvez tout de même faire vos choix ci-dessous : nous vous enverrons un rendu de votre volant une fois la commande passée, ou dès maintenant si vous préférez :": "עדיין אפשר לבצע את הבחירות שלכם למטה: נשלח לכם תצוגה מקדימה של ההגה לאחר ביצוע ההזמנה, או כבר עכשיו אם תעדיפו:",
    "Recevoir un aperçu avant de commander": "קבלת תצוגה מקדימה לפני ההזמנה",
    "Recevoir ma maquette": "לקבלת התצוגה המקדימה שלי",
    "Choose an option": "בחרו אפשרות",
    "Année + Modèle et Personnalisation": "שנה + דגם והתאמה אישית"
  };

  var KF_HE_MATERIALS = [
    ["carbone noir nid d'abeilles", "קרבון חלת דבש שחור", "m"], ["nid d'abeilles", "חלת דבש", "f"],
    ["carbone forgé", "קרבון פורג'ד", "m"], ["carbon forgé", "קרבון פורג'ד", "m"], ["carbone forge", "קרבון פורג'ד", "m"],
    ["carbone allégé", "קרבון קל", "m"], ["carbone allege", "קרבון קל", "m"],
    ["fibre sergée", "קרבון טוויל", "m"], ["fibre sergé", "קרבון טוויל", "m"],
    ["cuir perforé", "עור מחורר", "m"], ["cuir perfore", "עור מחורר", "m"], ["cuir lisse", "עור חלק", "m"], ["cuir surpiqué", "עור עם תפרים", "m"],
    ["forgé", "פורג'ד", "m"], ["forge", "פורג'ד", "m"],
    ["carbone", "קרבון", "m"], ["carbon", "קרבון", "m"], ["caborne", "קרבון", "m"],
    ["alcantara", "אלקנטרה", "f"], ["cuir", "עור", "m"], ["aluminium", "אלומיניום", "m"]
  ];
  var KF_HE_COLORS = [
    ["bleu ciel", "תכלת", "תכלת"], ["noir brillant", "שחור מבריק", "שחורה מבריקה"], ["noire brillante", "שחור מבריק", "שחורה מבריקה"],
    ["noir matte", "שחור מט", "שחורה מט"], ["noir mat", "שחור מט", "שחורה מט"], ["noire mat", "שחור מט", "שחורה מט"],
    ["rouge mat", "אדום מט", "אדומה מט"], ["argenté mat", "כסוף מט", "כסופה מט"],
    ["noire", "שחור", "שחורה"], ["noir", "שחור", "שחורה"], ["blanche", "לבן", "לבנה"], ["blanc", "לבן", "לבנה"],
    ["bleu", "כחול", "כחולה"], ["rouge", "אדום", "אדומה"], ["verte", "ירוק", "ירוקה"], ["vert", "ירוק", "ירוקה"],
    ["jaune", "צהוב", "צהובה"], ["rose", "ורוד", "ורודה"], ["violet", "סגול", "סגולה"], ["grise", "אפור", "אפורה"], ["gris", "אפור", "אפורה"],
    ["marron", "חום", "חומה"], ["beige", "בז'", "בז'"], ["orange", "כתום", "כתומה"], ["bordeaux", "בורדו", "בורדו"],
    ["argenté", "כסוף", "כסופה"], ["argent", "כסוף", "כסופה"], ["doré", "זהוב", "זהובה"], ["or", "זהוב", "זהובה"],
    ["matte", "מט", "מט"], ["mat", "מט", "מט"], ["brillant", "מבריק", "מבריקה"]
  ];
  var KF_HE_MISC = {
    'oui': 'כן', 'non': 'לא', 'avec': 'עם', 'sans': 'ללא', 'aucun': 'ללא', 'aucune': 'ללא',
    'allemagne': 'גרמניה', 'untitled answer': 'תשובה ללא כותרת', 'volant chauffant': 'הגה מחומם', 'm performance': 'M Performance',
    's-line': 'S-Line', 'r-line': 'R-Line', 'line assist': 'Line Assist'
  };
  function kfHeAnswer(text) {
    var t = text.trim().replace(/\s+/g, ' ').replace(/al+[eé]g[eé]e?/gi, 'allégé');
    if (!t) return null;
    var low = t.toLowerCase();
    if (KF_HE_MISC.hasOwnProperty(low)) return KF_HE_MISC[low];
    var rest = low, mat = null, parts = [], changed = false, andNext = false, gender = 'm';
    for (var i = 0; i < KF_HE_MATERIALS.length; i++) {
      var m = KF_HE_MATERIALS[i];
      if (rest === m[0] || rest.indexOf(m[0] + ' ') === 0) {
        mat = m[1]; gender = m[2]; rest = rest.slice(m[0].length).trim(); changed = true; break;
      }
    }
    while (rest) {
      var hit = null;
      for (var j = 0; j < KF_HE_COLORS.length; j++) {
        var c = KF_HE_COLORS[j];
        if (rest === c[0] || rest.indexOf(c[0] + ' ') === 0) { hit = c; break; }
      }
      if (hit) {
        var w = gender === 'f' ? hit[2] : hit[1];
        parts.push((andNext ? 'ו' : '') + w); andNext = false;
        rest = rest.slice(hit[0].length).trim(); changed = true;
      } else {
        var sp = rest.indexOf(' ');
        var tok = sp === -1 ? rest : rest.slice(0, sp);
        if (tok === 'et') { andNext = true; changed = true; }
        else if (KF_HE_MISC.hasOwnProperty(tok)) { parts.push(KF_HE_MISC[tok]); changed = true; }
        else parts.push(t.slice(t.length - rest.length, t.length - rest.length + tok.length));
        rest = sp === -1 ? '' : rest.slice(sp + 1).trim();
      }
    }
    if (!changed) return null;
    return (mat ? [mat] : []).concat(parts).join(' ');
  }
  function kfTranslateHe(text) {
    var trimmed = text.trim().replace(/\s+/g, ' ');
    var key = kfNormKey(trimmed);
    if (KF_PHRASE_MAP_HE.hasOwnProperty(key)) return KF_PHRASE_MAP_HE[key];
    var res = kfHeAnswer(trimmed);
    return res === null ? trimmed : res;
  }
  // ---------------------------------------------------------------------

  // --- Arabic layer (same architecture as the Hebrew one; data stays French) ---
  var KF_PHRASE_MAP_AR_RAW = [
    ["forme du volant", "شكل المقود"],
    ["type de poignées", "نوع القبضة"],
    ["poignées en cuir perforé", "قبضة من الجلد المثقّب"],
    ["poignées cuir perforé", "قبضة من الجلد المثقّب"],
    ["poignées en cuir lisse", "قبضة من الجلد الأملس"],
    ["poignées cuir lisse", "قبضة من الجلد الأملس"],
    ["poignées en alcantara", "قبضة من الألكانتارا"],
    ["poignées alcantara", "قبضة من الألكانتارا"],
    ["type d'insert", "نوع الإدراج"],
    ["insert en cuir lisse", "إدراج من الجلد الأملس"],
    ["insert cuir lisse", "إدراج من الجلد الأملس"],
    ["insert cuir", "إدراج من الجلد"],
    ["insert en alcantara", "إدراج من الألكانتارا"],
    ["insert alcantara", "إدراج من الألكانتارا"],
    ["insert en carbone", "إدراج من الكربون"],
    ["insert carbone", "إدراج من الكربون"],
    ["insert en carbone forgé", "إدراج من الكربون الفورجد"],
    ["insert carbone forgé", "إدراج من الكربون الفورجد"],
    ["couleur des surpiqures (pas visible sur le configurateur)", "لون الخياطة (غير ظاهر في أداة التخصيص)"],
    ["couleur des surpiqures", "لون الخياطة"],
    ["couleur des surpiqures du cache airbag", "لون خياطة غطاء الوسادة الهوائية"],
    ["rappel 12h", "علامة الساعة 12"],
    ["personnaliser le cache airbag ?", "هل تريد تخصيص غطاء الوسادة الهوائية؟"],
    ["matière cache airbag", "خامة غطاء الوسادة الهوائية"],
    ["couleur du logo", "لون الشعار"],
    ["shiftled", "ShiftLed"],
    ["boîte automatique?", "ناقل حركة أوتوماتيكي؟"],
    ["palettes txcp", "مجاديف TXCP"],
    ["couleur palettes carbone", "لون مجاديف الكربون"],
    ["couleur palettes carbone allegee", "لون مجاديف الكربون الخفيف"],
    ["couleur palettes allegee", "لون مجاديف الكربون الخفيف"],
    ["couleur palettes carbone forgé", "لون مجاديف الكربون الفورجد"],
    ["avez-vous l'option volant chauffant?", "هل سيارتك مزوّدة بخيار المقود المدفأ؟"],
    ["ajout du pack volant complet (commande au volant, électronique de palette, airbag complet)", "إضافة حزمة المقود الكاملة (أزرار المقود، إلكترونيات المجاديف، وسادة هوائية كاملة)"],
    ["ajout du pack volant complet (électronique de palette, airbag complet)", "إضافة حزمة المقود الكاملة (إلكترونيات المجاديف، وسادة هوائية كاملة)"],
    ["modèle du véhicule et indiquez vos préférences de configuration (surpiqûres, couleur du rappel 12:00, style de carbone,etc.). nous en tiendrons compte lors de la fabrication.", "موديل السيارة وحدّد تفضيلات التهيئة (الخياطة، لون علامة الساعة 12، نمط الكربون، إلخ). سنأخذ ذلك في الاعتبار أثناء التصنيع."],
    ["envoyez une photo de votre volant actuel", "أرسل صورة لمقودك الحالي"],
    ["personnaliser le contour des boutons ?", "هل تريد تخصيص إطار الأزرار؟"],
    ["contours des boutons", "إطار الأزرار"],
    ["logo", "الشعار"],
    ["couleur des lettres du logo", "لون حروف الشعار"],
    ["couleur logo", "لون الشعار"],
    ["bouton style r8", "زر بنمط R8"],
    ["logo insert", "شعار الإدراج"],
    ["garniture supplémentaire", "كسوة إضافية"],
    ["garnitures supplémentaires", "كسوات إضافية"],
    ["coutures cache airbag", "خياطة غطاء الوسادة الهوائية"],
    ["personnaliser la garniture centrale", "هل تريد تخصيص الكسوة المركزية؟"],
    ["personnaliser les garnitures ?", "هل تريد تخصيص الكسوات؟"],
    ["couleur garnitures", "لون الكسوات"],
    ["matière garniture centrale", "خامة الكسوة المركزية"],
    ["votre véhicule a t'il l'option line assist ? (volant vibrant) ou volant chauffant?", "هل سيارتك مزوّدة بخيار Line Assist (مقود يهتز) أو المقود المدفأ؟"],
    ["ronde", "دائري"],
    ["méplat", "مسطّح من الأسفل"],
    ["sportive", "رياضي"]
  ];
  var KF_PHRASE_MAP_AR = {};
  KF_PHRASE_MAP_AR_RAW.forEach(function (p) { KF_PHRASE_MAP_AR[kfNormKey(p[0])] = p[1]; });
  var KF_UI_STRINGS_AR = {
    "Valider la configuration": "تأكيد التهيئة",
    "Ajouter au panier": "أضف إلى السلة",
    "Suivant": "التالي",
    "Préparation de votre configuration…": "جارٍ تجهيز تهيئتك…",
    "Ajout en cours…": "جارٍ الإضافة…",
    "Erreur — réessayez": "خطأ، أعد المحاولة",
    "Merci de répondre avant de continuer.": "يُرجى الإجابة قبل المتابعة.",
    "Configurateur bientôt disponible": "أداة التخصيص ستتوفر قريبًا",
    "Choisir un fichier": "اختر ملفًا",
    "En savoir plus": "اعرف المزيد",
    "Chargement…": "جارٍ التحميل…",
    "Impossible de charger le guide. ": "تعذر تحميل الدليل. ",
    "Ouvrir dans un nouvel onglet": "فتح في تبويب جديد",
    "Préparation du configurateur…": "جارٍ تجهيز أداة التخصيص…",
    "Fermer": "إغلاق",
    "Question précédente": "السؤال السابق",
    "(envoi…)": "(جارٍ الإرسال…)",
    "Le configurateur n'affiche qu'un rendu en forme méplat. Si vous choisissez la forme ronde, votre volant sera bien fabriqué dans cette forme.": "تعرض أداة التخصيص معاينة بالشكل المسطّح فقط. إذا اخترت الشكل الدائري، فسيُصنَّع مقودك بهذا الشكل فعلًا.",
    "Vous pouvez tout de même faire vos choix ci-dessous : nous vous enverrons un rendu de votre volant une fois la commande passée, ou dès maintenant si vous préférez :": "ما زال بإمكانك تحديد خياراتك أدناه: سنرسل إليك معاينة لمقودك بعد تقديم الطلب، أو الآن إن كنت تفضّل ذلك:",
    "Recevoir un aperçu avant de commander": "احصل على معاينة قبل الطلب",
    "Recevoir ma maquette": "احصل على المعاينة",
    "Choose an option": "اختر خيارًا",
    "Année + Modèle et Personnalisation": "السنة + الموديل والتخصيص"
  };

  var KF_AR_MATERIALS = [
    ["carbone noir nid d'abeilles", "كربون قرص العسل أسود", "m"], ["nid d'abeilles", "قرص العسل", "m"],
    ["carbone forgé", "كربون فورجد", "m"], ["carbon forgé", "كربون فورجد", "m"], ["carbone forge", "كربون فورجد", "m"],
    ["carbone allégé", "كربون خفيف", "m"], ["carbone allege", "كربون خفيف", "m"],
    ["fibre sergée", "كربون تويل", "m"], ["fibre sergé", "كربون تويل", "m"],
    ["cuir perforé", "جلد مثقّب", "m"], ["cuir perfore", "جلد مثقّب", "m"], ["cuir lisse", "جلد أملس", "m"], ["cuir surpiqué", "جلد بخياطة", "m"],
    ["forgé", "فورجد", "m"], ["forge", "فورجد", "m"],
    ["carbone", "كربون", "m"], ["carbon", "كربون", "m"], ["caborne", "كربون", "m"],
    ["alcantara", "ألكانتارا", "f"], ["cuir", "جلد", "m"], ["aluminium", "ألومنيوم", "m"]
  ];
  var KF_AR_COLORS = [
    ["bleu ciel", "سماوي", "سماوية"], ["noir brillant", "أسود لامع", "سوداء لامعة"], ["noire brillante", "أسود لامع", "سوداء لامعة"],
    ["noir matte", "أسود مطفي", "سوداء مطفية"], ["noir mat", "أسود مطفي", "سوداء مطفية"], ["noire mat", "أسود مطفي", "سوداء مطفية"],
    ["rouge mat", "أحمر مطفي", "حمراء مطفية"], ["argenté mat", "فضي مطفي", "فضية مطفية"],
    ["noire", "أسود", "سوداء"], ["noir", "أسود", "سوداء"], ["blanche", "أبيض", "بيضاء"], ["blanc", "أبيض", "بيضاء"],
    ["bleu", "أزرق", "زرقاء"], ["rouge", "أحمر", "حمراء"], ["verte", "أخضر", "خضراء"], ["vert", "أخضر", "خضراء"],
    ["jaune", "أصفر", "صفراء"], ["rose", "وردي", "وردية"], ["violet", "بنفسجي", "بنفسجية"], ["grise", "رمادي", "رمادية"], ["gris", "رمادي", "رمادية"],
    ["marron", "بني", "بنية"], ["beige", "بيج", "بيج"], ["orange", "برتقالي", "برتقالية"], ["bordeaux", "عنابي", "عنابية"],
    ["argenté", "فضي", "فضية"], ["argent", "فضي", "فضية"], ["doré", "ذهبي", "ذهبية"], ["or", "ذهبي", "ذهبية"],
    ["matte", "مطفي", "مطفية"], ["mat", "مطفي", "مطفية"], ["brillant", "لامع", "لامعة"]
  ];
  var KF_AR_MISC = {
    'oui': 'نعم', 'non': 'لا', 'avec': 'مع', 'sans': 'بدون', 'aucun': 'بدون', 'aucune': 'بدون',
    'allemagne': 'ألمانيا', 'untitled answer': 'إجابة بدون عنوان', 'volant chauffant': 'مقود مدفأ', 'm performance': 'M Performance',
    's-line': 'S-Line', 'r-line': 'R-Line', 'line assist': 'Line Assist'
  };
  function kfArAnswer(text) {
    var t = text.trim().replace(/\s+/g, ' ').replace(/al+[eé]g[eé]e?/gi, 'allégé');
    if (!t) return null;
    var low = t.toLowerCase();
    if (KF_AR_MISC.hasOwnProperty(low)) return KF_AR_MISC[low];
    var rest = low, mat = null, parts = [], changed = false, andNext = false, gender = 'm';
    for (var i = 0; i < KF_AR_MATERIALS.length; i++) {
      var m = KF_AR_MATERIALS[i];
      if (rest === m[0] || rest.indexOf(m[0] + ' ') === 0) {
        mat = m[1]; gender = m[2]; rest = rest.slice(m[0].length).trim(); changed = true; break;
      }
    }
    while (rest) {
      var hit = null;
      for (var j = 0; j < KF_AR_COLORS.length; j++) {
        var c = KF_AR_COLORS[j];
        if (rest === c[0] || rest.indexOf(c[0] + ' ') === 0) { hit = c; break; }
      }
      if (hit) {
        var w = gender === 'f' ? hit[2] : hit[1];
        parts.push((andNext ? 'و' : '') + w); andNext = false;
        rest = rest.slice(hit[0].length).trim(); changed = true;
      } else {
        var sp = rest.indexOf(' ');
        var tok = sp === -1 ? rest : rest.slice(0, sp);
        if (tok === 'et') { andNext = true; changed = true; }
        else if (KF_AR_MISC.hasOwnProperty(tok)) { parts.push(KF_AR_MISC[tok]); changed = true; }
        else parts.push(t.slice(t.length - rest.length, t.length - rest.length + tok.length));
        rest = sp === -1 ? '' : rest.slice(sp + 1).trim();
      }
    }
    if (!changed) return null;
    return (mat ? [mat] : []).concat(parts).join(' ');
  }
  function kfTranslateAr(text) {
    var trimmed = text.trim().replace(/\s+/g, ' ');
    var key = kfNormKey(trimmed);
    if (KF_PHRASE_MAP_AR.hasOwnProperty(key)) return KF_PHRASE_MAP_AR[key];
    var res = kfArAnswer(trimmed);
    return res === null ? trimmed : res;
  }
  // ---------------------------------------------------------------------

  var kfTranslateCache = {};
  function kfTranslate(text) {
    if (!text) return text;
    if (kfIsArabic()) {
      var arKey = 'ar:' + text;
      if (!kfTranslateCache.hasOwnProperty(arKey)) kfTranslateCache[arKey] = kfTranslateAr(text);
      return kfTranslateCache[arKey];
    }
    if (kfIsHebrew()) {
      var heKey = 'he:' + text;
      if (!kfTranslateCache.hasOwnProperty(heKey)) kfTranslateCache[heKey] = kfTranslateHe(text);
      return kfTranslateCache[heKey];
    }
    if (kfIsSpanish()) {
      var esKey = 'es:' + text;
      if (!kfTranslateCache.hasOwnProperty(esKey)) kfTranslateCache[esKey] = kfTranslateEs(text);
      return kfTranslateCache[esKey];
    }
    if (kfIsPortuguese()) {
      var ptKey = 'pt:' + text;
      if (!kfTranslateCache.hasOwnProperty(ptKey)) kfTranslateCache[ptKey] = kfTranslatePt(text);
      return kfTranslateCache[ptKey];
    }
    if (kfIsItalian()) {
      var itKey = 'it:' + text;
      if (!kfTranslateCache.hasOwnProperty(itKey)) kfTranslateCache[itKey] = kfTranslateIt(text);
      return kfTranslateCache[itKey];
    }
    if (kfIsDutch()) {
      var nlKey = 'nl:' + text;
      if (!kfTranslateCache.hasOwnProperty(nlKey)) kfTranslateCache[nlKey] = kfTranslateNl(text);
      return kfTranslateCache[nlKey];
    }
    if (kfIsGerman()) {
      var deKey = 'de:' + text;
      if (!kfTranslateCache.hasOwnProperty(deKey)) kfTranslateCache[deKey] = kfTranslateDe(text);
      return kfTranslateCache[deKey];
    }
    if (!kfIsEnglish()) return text;
    if (kfTranslateCache.hasOwnProperty(text)) return kfTranslateCache[text];

    var trimmed = text.trim().replace(/\s+/g, ' ');
    var lower = trimmed.toLowerCase();
    var result;
    var enKey = kfNormKey(trimmed), enAns;
    if (KF_PHRASE_MAP_EN.hasOwnProperty(enKey)) {
      result = KF_PHRASE_MAP_EN[enKey];
    } else if ((enAns = kfEnAnswer(trimmed)) !== null) {
      result = enAns;
    } else {
      result = trimmed;
      for (var i = 0; i < KF_WORD_MAP.length; i++) {
        var fr = KF_WORD_MAP[i][0];
        var en = KF_WORD_MAP[i][1];
        var re = new RegExp('(^|\\s)' + fr.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '($|\\s)', 'gi');
        result = result.replace(re, function (m, p1, p2) { return p1 + en + p2; });
      }
    }
    kfTranslateCache[text] = result;
    return result;
  }

  // Static UI strings (buttons, messages) used throughout this file.
  var KF_UI_STRINGS = {
    "Valider la configuration": "Confirm configuration",
    "Ajouter au panier": "Add to cart",
    "Suivant": "Next",
    "Préparation de votre configuration…": "Preparing your configuration…",
    "Ajout en cours…": "Adding…",
    "Erreur — réessayez": "Error, please try again",
    "Merci de répondre avant de continuer.": "Please answer before continuing.",
    "Configurateur bientôt disponible": "Configurator coming soon",
    "Choisir un fichier": "Choose a file",
    "En savoir plus": "Learn more",
    "Chargement…": "Loading…",
    "Impossible de charger le guide. ": "Unable to load the guide. ",
    "Ouvrir dans un nouvel onglet": "Open in a new tab",
    "Préparation du configurateur…": "Preparing configurator…",
    "Fermer": "Close",
    "Question précédente": "Previous question",
    "(envoi…)": "(uploading…)",
    "Le configurateur n'affiche qu'un rendu en forme méplat. Si vous choisissez la forme ronde, votre volant sera bien fabriqué dans cette forme.": "The configurator only shows a flat-bottom preview. If you choose the round shape, your steering wheel will still be made in that shape.",
    "Vous pouvez tout de même faire vos choix ci-dessous : nous vous enverrons un rendu de votre volant une fois la commande passée, ou dès maintenant si vous préférez :": "You can still make your choices below: we will send you a preview of your steering wheel once your order is placed, or right now if you would rather:",
    "Recevoir un aperçu avant de commander": "Get a preview before ordering",
    "Recevoir ma maquette": "Get my preview",
    "Choose an option": "Choose an option",
    "Année + Modèle et Personnalisation": "Year + Model and Customization"
  };
  var KF_WHATSAPP_PHONE = '33782793625';

  // WhatsApp contact links on a product page (buy-box button, "Contacter" card,
  // expert card, floating bubble) are static in the theme and used to send a
  // bare "voici ma configuration :" with nothing after it. They are rewritten
  // here to carry the product and, once the shopper has touched the
  // configurator, every spec they chose. Spec lines stay in French (data
  // language, read by staff); only the intro/total wording follows the locale.
  var KF_WA_TEXT = {
    fr: { hello: 'Bonjour,', interested: 'Je serais intéressé par :', cfg: 'Voici ma configuration :', total: 'Total :' },
    en: { hello: 'Hello,', interested: 'I would be interested in:', cfg: 'Here is my configuration:', total: 'Total:' },
    es: { hello: 'Hola,', interested: 'Estaría interesado en:', cfg: 'Esta es mi configuración:', total: 'Total:' },
    it: { hello: 'Buongiorno,', interested: 'Sarei interessato a:', cfg: 'Ecco la mia configurazione:', total: 'Totale:' },
    nl: { hello: 'Hallo,', interested: 'Ik ben geïnteresseerd in:', cfg: 'Dit is mijn configuratie:', total: 'Totaal:' },
    de: { hello: 'Guten Tag,', interested: 'Ich interessiere mich für:', cfg: 'Hier ist meine Konfiguration:', total: 'Gesamtpreis:' },
    he: { hello: 'שלום,', interested: 'אני מעוניין ב:', cfg: 'הנה התצורה שלי:', total: 'סה״כ:' },
    ar: { hello: 'مرحبًا،', interested: 'أنا مهتم بـ:', cfg: 'هذه تهيئتي:', total: 'الإجمالي:' },
    pt: { hello: 'Olá,', interested: 'Tenho interesse em:', cfg: 'Esta é a minha configuração:', total: 'Total:' }
  };
  function kfWaLang() {
    return kfIsPortuguese() ? 'pt' : kfIsArabic() ? 'ar' : kfIsHebrew() ? 'he' : kfIsDutch() ? 'nl' : kfIsGerman() ? 'de' : kfIsItalian() ? 'it' : kfIsSpanish() ? 'es' : kfIsEnglish() ? 'en' : 'fr';
  }
  function kfWaBuildText(info) {
    var t = KF_WA_TEXT[kfWaLang()];
    var out = t.hello + '\n\n' + t.interested + ' ' + info.name;
    if (info.url) out += '\n' + info.url;
    if (info.lines && info.lines.length) {
      out += '\n\n' + t.cfg + '\n' + info.lines.join('\n');
      if (info.total) out += '\n' + t.total + ' ' + info.total;
    }
    return out;
  }
  function kfWaSyncLinks(info) {
   try { // secondary feature: must never be able to break the configurator
    var text = kfWaBuildText(info);
    document.querySelectorAll('a[href*="api.whatsapp.com/send"], a[href*="wa.me"]').forEach(function (a) {
      if (a.classList.contains('kf-coming-soon-cta')) return; // has its own "preview" message
      var u;
      try { u = new URL(a.href, location.href); } catch (e) { return; }
      if (u.searchParams.get('phone') !== KF_WHATSAPP_PHONE) return;
      // Only the generic "here is my configuration" links; leave e.g. the warranty link alone.
      if (!a.dataset.kfWa && !/configur|Konfiguration|תצורה|تهيئة/i.test(u.searchParams.get('text') || '')) return;
      a.dataset.kfWa = '1';
      u.searchParams.set('text', text);
      a.setAttribute('href', u.toString());
    });
   } catch (e) { /* keep the static links as they were */ }
  }
  // Before the spec has loaded we only know the product: still better than a
  // message that does not say which model the shopper is asking about.
  function kfWaPreSpec(root) {
    var m = location.pathname.match(/\/products\/([^/?#]+)/);
    var h = root.dataset.productHandle || (m ? m[1] : null);
    var t = root.querySelector('.kf-price-bar h2');
    var name = (t && t.textContent.trim()) || (document.title || '').split(' – ')[0].trim();
    kfWaSyncLinks({ name: name, url: h ? location.origin + '/products/' + h : '', lines: null, total: null });
  }
  function kfUiText(text) {
    if (kfIsArabic()) return KF_UI_STRINGS_AR.hasOwnProperty(text) ? KF_UI_STRINGS_AR[text] : text;
    if (kfIsHebrew()) return KF_UI_STRINGS_HE.hasOwnProperty(text) ? KF_UI_STRINGS_HE[text] : text;
    if (kfIsSpanish()) return KF_UI_STRINGS_ES.hasOwnProperty(text) ? KF_UI_STRINGS_ES[text] : text;
    if (kfIsPortuguese()) return KF_UI_STRINGS_PT.hasOwnProperty(text) ? KF_UI_STRINGS_PT[text] : text;
    if (kfIsItalian()) return KF_UI_STRINGS_IT.hasOwnProperty(text) ? KF_UI_STRINGS_IT[text] : text;
    if (kfIsDutch()) return KF_UI_STRINGS_NL.hasOwnProperty(text) ? KF_UI_STRINGS_NL[text] : text;
    if (kfIsGerman()) return KF_UI_STRINGS_DE.hasOwnProperty(text) ? KF_UI_STRINGS_DE[text] : text;
    if (!kfIsEnglish()) return text;
    return KF_UI_STRINGS.hasOwnProperty(text) ? KF_UI_STRINGS[text] : text;
  }
  // ---------------------------------------------------------------------

  var KF_GUIDE_LINKS = [
    { match: n => /poign/i.test(n), url: 'https://atelieroem.fr/pages/alcantara-ou-cuir' },
    { match: n => /insert/i.test(n), url: 'https://atelieroem.fr/pages/materiaux-de-linsert' },
    { match: n => /palette/i.test(n) && !/pack/i.test(n), url: 'https://atelieroem.fr/pages/les-palettes-txcp' },
    { match: n => /style r8/i.test(n), url: 'https://atelieroem.fr/blogs/news/boutons-style-r8-sur-volant-vag-installer-start-stop-et-drive-select' }
  ];

  function guideUrlFor(questionName) {
    const found = KF_GUIDE_LINKS.find(g => g.match(questionName));
    if (!found) return null;
    if (kfIsArabic()) return found.url.replace('https://atelieroem.fr/', 'https://atelieroem.fr/ar/');
    if (kfIsHebrew()) return found.url.replace('https://atelieroem.fr/', 'https://atelieroem.fr/he/');
    if (kfIsEnglish()) return found.url.replace('https://atelieroem.fr/', 'https://atelieroem.fr/en/');
    if (kfIsDutch()) return found.url.replace('https://atelieroem.fr/', 'https://atelieroem.fr/nl/');
    if (kfIsGerman()) return found.url.replace('https://atelieroem.fr/', 'https://atelieroem.fr/de/');
    if (kfIsPortuguese()) return found.url.replace('https://atelieroem.fr/', 'https://atelieroem.fr/' + (kfIsBrazilian() ? 'pt-br/' : 'pt/'));
    if (kfIsItalian()) return found.url.replace('https://atelieroem.fr/', 'https://atelieroem.fr/it/');
    return kfIsSpanish() ? found.url.replace('https://atelieroem.fr/', 'https://atelieroem.fr/es/') : found.url;
  }

  // The "Forme du volant" question's photo render always shows the
  // flat-bottom (méplat) shape regardless of which shape the shopper picks —
  // only the manufactured wheel actually changes shape. Surface that as a
  // small caption under the question title so it isn't mistaken for a bug.
  var KF_SHAPE_QUESTION_NOTE = "Le configurateur n'affiche qu'un rendu en forme méplat. Si vous choisissez la forme ronde, votre volant sera bien fabriqué dans cette forme.";
  function shapeQuestionNoteText(questionName) {
    return (questionName || '').trim().toLowerCase() === 'forme du volant' ? KF_SHAPE_QUESTION_NOTE : null;
  }
  function appendShapeQuestionNote(q, div) {
    var note = shapeQuestionNoteText(q.name);
    if (!note) return;
    var p = document.createElement('p');
    p.className = 'kf-question-note';
    p.textContent = kfUiText(note);
    div.appendChild(p);
  }

  var guideContentCache = {};

  function ensureGuidePopup() {
    let popup = document.querySelector('[data-kf-guide-popup]');
    if (popup) return popup;
    popup = document.createElement('div');
    popup.className = 'kf-guide-popup';
    popup.setAttribute('data-kf-guide-popup', '');
    popup.hidden = true;
    popup.innerHTML = `
      <div class="kf-guide-popup-backdrop" data-kf-guide-close></div>
      <div class="kf-guide-popup-panel">
        <button type="button" class="kf-guide-popup-close" data-kf-guide-close aria-label="${kfUiText('Fermer')}">&times;</button>
        <div class="kf-guide-popup-loading" data-kf-guide-loading>${kfUiText('Chargement…')}</div>
        <iframe class="kf-guide-popup-iframe" data-kf-guide-iframe hidden></iframe>
      </div>
    `;
    document.body.appendChild(popup);
    popup.querySelectorAll('[data-kf-guide-close]').forEach(el => {
      el.addEventListener('click', () => { popup.hidden = true; });
    });
    return popup;
  }

  function buildGuideDoc(html) {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const source = doc.querySelector('.page-default__rte')
      || doc.querySelector('.page-default')
      || doc.querySelector('main .rte')
      || doc.querySelector('main');
    const inner = source ? source.innerHTML : '<p>Contenu introuvable.</p>';
    return `<!doctype html><html><head><meta charset="utf-8">` +
      `<meta name="viewport" content="width=device-width, initial-scale=1.0">` +
      `<style>html,body{background:#0d0d0d;color:#eee;margin:0;font-family:sans-serif;}` +
      `body{padding:24px;}</style></head><body>${inner}</body></html>`;
  }

  function openGuidePopup(url) {
    const popup = ensureGuidePopup();
    const loading = popup.querySelector('[data-kf-guide-loading]');
    const iframe = popup.querySelector('[data-kf-guide-iframe]');
    popup.hidden = false;

    if (guideContentCache[url]) {
      iframe.srcdoc = guideContentCache[url];
      iframe.hidden = false;
      loading.hidden = true;
      return;
    }

    iframe.hidden = true;
    loading.hidden = false;
    loading.textContent = kfUiText('Chargement…');

    fetch(url)
      .then(r => { if (!r.ok) throw new Error('HTTP ' + r.status); return r.text(); })
      .then(html => {
        const docString = buildGuideDoc(html);
        guideContentCache[url] = docString;
        iframe.srcdoc = docString;
        iframe.hidden = false;
        loading.hidden = true;
      })
      .catch(() => {
        loading.textContent = '';
        loading.append(kfUiText('Impossible de charger le guide. '));
        const link = document.createElement('a');
        link.href = url;
        link.target = '_blank';
        link.rel = 'noopener';
        link.textContent = kfUiText('Ouvrir dans un nouvel onglet');
        loading.appendChild(link);
      });
  }

  var CLOUDINARY_CLOUD_NAME = 'iroz2dks';
  var CLOUDINARY_UPLOAD_PRESET = 'kf_uploads';
  var CLOUDINARY_FOLDER = 'atelieroem-configurateur';

  // The Liquid-embedded `product.variants` (baked into the page at render
  // time, via data-variants) is silently capped at 250 by Shopify itself —
  // products with more configurator price points than that lose the rest.
  // The Storefront API has no such cap (it paginates), so once the page
  // loads we quietly fetch the complete variant list in the background and
  // swap it in; the embedded (possibly-truncated) list keeps the
  // configurator usable instantly in the meantime.
  var KF_SHOP_DOMAIN = 'kfhqhh-mp.myshopify.com';
  var KF_STOREFRONT_TOKEN = '793937773ccaf5ad5e3a8916edf692ee';
  var KF_STOREFRONT_API_VERSION = '2024-10';

  async function fetchAllVariantsViaStorefront(handle, inEur) {
    // inEur: visitors browsing in another currency (Markets local currencies, e.g. ILS, GBP, USD) get the
    // catalog prices in EUR, the currency the configurator totals are computed in.
    const query = 'query($handle: String!, $cursor: String)' + (inEur ? ' @inContext(country: FR)' : '') + ' {' +
      ' product(handle: $handle) {' +
      '   variants(first: 250, after: $cursor) {' +
      '     edges { cursor node { id price { amount } } }' +
      '     pageInfo { hasNextPage }' +
      '   }' +
      ' } }';
    let cursor = null;
    const all = [];
    for (let i = 0; i < 20; i++) { // safety cap on pagination loops
      const res = await fetch(`https://${KF_SHOP_DOMAIN}/api/${KF_STOREFRONT_API_VERSION}/graphql.json`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': KF_STOREFRONT_TOKEN,
        },
        body: JSON.stringify({ query, variables: { handle, cursor } }),
      });
      const data = await res.json();
      const v = data && data.data && data.data.product && data.data.product.variants;
      if (!v) break;
      for (const edge of v.edges) {
        const id = Number(String(edge.node.id).split('/').pop());
        all.push({ id, price: parseFloat(edge.node.price.amount) });
      }
      if (!v.pageInfo.hasNextPage) break;
      cursor = v.edges[v.edges.length - 1].cursor;
    }
    return all;
  }

  function escapeHtml(s) {
    return (s || '').replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
  }

  function uploadToCloudinary(fileOrBlob, filename) {
    const url = `https://api.cloudinary.com/v1_1/${CLOUDINARY_CLOUD_NAME}/auto/upload`;
    const formData = new FormData();
    formData.append('file', fileOrBlob, filename || undefined);
    formData.append('upload_preset', CLOUDINARY_UPLOAD_PRESET);
    formData.append('folder', CLOUDINARY_FOLDER);
    return fetch(url, { method: 'POST', body: formData })
      .then(r => r.json())
      .then(data => data.secure_url || null)
      .catch(() => null);
  }

  function initConfigurator(root) {
    const specUrl = root.dataset.specUrl;
    // Non-EUR visitors: the Liquid-embedded prices are in their currency, but the configurator totals are in EUR,
    // so matching a variant needs the EUR list (fetched below). The local prices are kept by variant id to show
    // exactly what the cart will charge.
    const kfCur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
    const kfNonEur = kfCur !== 'EUR';
    const kfRate = kfNonEur ? (parseFloat(Shopify.currency.rate) || 1) : 1;
    const kfLiquidVariants = JSON.parse(root.dataset.variants || '[]');
    const kfLocalPrice = {};
    if (kfNonEur) kfLiquidVariants.forEach(v => { kfLocalPrice[v.id] = v.price; });
    let variants = kfNonEur ? [] : kfLiquidVariants;
    function kfFmtLocal(amount, digits) {
      try {
        return new Intl.NumberFormat((kfIsHebrew() || kfIsArabic()) ? 'en-US' : (document.documentElement.lang || undefined), { style: 'currency', currency: kfCur, currencyDisplay: 'narrowSymbol', minimumFractionDigits: digits, maximumFractionDigits: digits }).format(amount);
      } catch (e) { return amount.toFixed(digits) + ' ' + kfCur; }
    }
    // Prefer an explicit data attribute if a template ever sets one, but every
    // product page this configurator runs on lives at /products/{handle}, so
    // fall back to parsing the handle straight out of the URL — this avoids
    // depending on every per-product template being edited individually.
    const urlHandleMatch = location.pathname.match(/\/products\/([^/?]+)/);
    const productHandle = root.dataset.productHandle || (urlHandleMatch ? urlHandleMatch[1] : null);
    if (productHandle) {
      fetchAllVariantsViaStorefront(productHandle, kfNonEur).then(full => {
        if (full && (kfNonEur ? full.length > 0 : full.length > variants.length)) {
          variants = full;
          if (spec) renderPrice(); // spec may still be loading — the initial renderPrice() call below will pick up the fuller list once it runs
        }
      }).catch(() => { /* keep using the embedded (possibly truncated) list on failure */ });
    }
    let spec, config = {};
    const freeTextValues = {};
    const fileNames = {};
    const fileUrls = {};
    let touched = false; // shopper has interacted with the configurator (defaults alone are not a config)
    let currentIndex = 0;
    const mobile = window.matchMedia('(max-width: 1024px)').matches;

    root.addEventListener('contextmenu', e => e.preventDefault());
    root.addEventListener('dragstart', e => e.preventDefault());
    root.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('a, [data-kf-close]')) return;
      touched = true;
      setTimeout(syncWhatsAppLinks, 0);
    }, true);
    root.addEventListener('input', function () {
      touched = true;
      setTimeout(syncWhatsAppLinks, 0);
    }, true);

    const layerstack = root.querySelector('[data-kf-layerstack]');
    const priceEl = root.querySelector('[data-kf-price]');
    const noteEl = root.querySelector('[data-kf-variant-note]');
    const klarnaBadgeEl = root.querySelector('[data-kf-klarna]');
    const klarnaAmountEl = root.querySelector('[data-kf-klarna-amount]');
    const priceRow = document.createElement('div');
    priceRow.className = 'kf-price-row';
    priceEl.parentNode.insertBefore(priceRow, priceEl);
    const priceGroup = document.createElement('div');
    priceGroup.className = 'kf-price-group';
    priceRow.appendChild(priceGroup);
    priceGroup.appendChild(priceEl);
    if (klarnaBadgeEl) {
      klarnaBadgeEl.hidden = false;
      priceGroup.appendChild(klarnaBadgeEl);
    }
    const guideSlot = document.createElement('div');
    guideSlot.className = 'kf-guide-slot';
    priceRow.appendChild(guideSlot);
    const progressEl = root.querySelector('[data-kf-progress]');
    const progressBarFillEl = root.querySelector('[data-kf-progress-bar]');
    const questionEl = root.querySelector('[data-kf-current-question]');
    const prevBtn = root.querySelector('[data-kf-prev]');
    const nextBtn = root.querySelector('[data-kf-next]');
    const requiredHintEl = root.querySelector('[data-kf-required-hint]');
    const ctaEl = root.querySelector('[data-kf-cta]');
    const loadingEl = root.querySelector('[data-kf-loading]');
    const loadingBarEl = root.querySelector('[data-kf-loading-bar]');
    const loadingLabelEl = root.querySelector('[data-kf-loading-label]');
    if (loadingLabelEl) loadingLabelEl.textContent = kfUiText(loadingLabelEl.textContent);
    const prevBtnLabelEl = prevBtn && prevBtn.getAttribute('aria-label');
    if (prevBtn && prevBtnLabelEl) prevBtn.setAttribute('aria-label', kfUiText(prevBtnLabelEl));
    if (nextBtn && nextBtn.textContent.trim() === 'Suivant') nextBtn.textContent = kfUiText('Suivant');

    function priceFor(questionId, answerId) {
      const extra = spec.extraPrices[questionId];
      if (!extra) return 0;
      return parseFloat(extra[answerId] || 0);
    }

    function isQuestionDisabled(questionId) {
      for (const rule of spec.rules) {
        const disables = rule.then.some(t => t.type === 'DISABLE_QUESTION' && t.questionId === questionId);
        if (!disables) continue;
        const matches = rule.when.every(cond => config[cond.path[1]] === cond.value);
        if (matches) return true;
      }
      return false;
    }

    function visibleQuestions() {
      return spec.questions.filter(q => !isQuestionDisabled(q.id));
    }

    function isRequired(q) {
      return false;
    }

    function hasAnswer(q) {
      if (q.inputType === 'text') return !!(freeTextValues[q.id] && freeTextValues[q.id].trim());
      if (q.inputType === 'fileinput') return !!fileUrls[q.id];
      return !!config[q.id];
    }

    function computeTotal() {
      let total = spec.basePrice;
      for (const q of spec.questions) {
        if (isQuestionDisabled(q.id)) continue;
        const ans = config[q.id];
        if (ans) total += priceFor(q.id, ans);
      }
      return Math.round(total * 100) / 100;
    }

    function findNearestVariant(total) {
      if (!variants.length) return null;
      let best = variants[0];
      for (const v of variants) {
        if (Math.abs(v.price - total) < Math.abs(best.price - total)) best = v;
      }
      return best;
    }

    let layerRenderToken = 0;

    function preloadImage(url) {
      return new Promise((resolve) => {
        const img = new Image();
        img.crossOrigin = 'anonymous';
        img.draggable = false;
        img.onload = () => resolve(img);
        img.onerror = () => resolve(img);
        img.src = url;
      });
    }

    function allThumbnailUrls() {
      const urls = new Set();
      for (const q of spec.questions) {
        for (const a of (q.answers || [])) {
          if (a.thumbnail) urls.add(a.thumbnail);
        }
      }
      return urls;
    }

    function thumbnailUrlsFor(q) {
      const urls = new Set();
      for (const a of (q.answers || [])) {
        if (a.thumbnail) urls.add(a.thumbnail);
      }
      return urls;
    }

    function isSlowConnection() {
      const conn = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
      if (!conn) return false;
      if (conn.saveData) return true;
      return /^(slow-2g|2g|3g)$/.test(conn.effectiveType || '');
    }

    const warmedThumbs = new Set();
    let backgroundWarmupStarted = false;

    function warmupRemainingThumbnails() {
      if (backgroundWarmupStarted) return;
      backgroundWarmupStarted = true;
      const remaining = Array.from(allThumbnailUrls()).filter(u => !warmedThumbs.has(u));
      // Fire-and-forget: don't block the UI, just warm the browser cache so every
      // question's thumbnails are already loaded by the time the user reaches it.
      remaining.forEach(u => { preloadImage(u); warmedThumbs.add(u); });
    }

    function warmupQuestionThumbnails(q) {
      thumbnailUrlsFor(q).forEach(u => {
        if (!warmedThumbs.has(u)) { preloadImage(u); warmedThumbs.add(u); }
      });
    }

    function preloadWithProgress(urls, onProgress) {
      const list = Array.from(urls);
      if (!list.length) { onProgress(1); return Promise.resolve(); }
      let done = 0;
      return Promise.all(list.map(url => preloadImage(url).then(img => {
        done++;
        onProgress(done / list.length);
        return img;
      })));
    }

    function normName(s) {
      return (s || '').trim().toLowerCase()
        .normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    }

    // A "Palette ..." finish question (e.g. "Palettes TXCP") shows a generic,
    // uncolored paddle layer as soon as a finish is picked. Once its matching
    // "Couleur Palette ..." refinement question is answered, that colored
    // layer should replace it — not stack on top of it — so we skip the
    // generic finish layer whenever a color refinement is active.
    function activeLayerUrls() {
      const hasActiveColorRefinement = spec.questions.some(q => {
        if (!normName(q.name).startsWith('couleur palette')) return false;
        if (isQuestionDisabled(q.id)) return false;
        return !!config[q.id];
      });
      const urls = [];
      for (const part of spec.parts) {
        if (isQuestionDisabled(part.questionId)) continue;
        const question = spec.questions.find(q => q.id === part.questionId);
        if (question && hasActiveColorRefinement && normName(question.name).startsWith('palette')) continue;
        const url = part.layerByAnswer[config[part.questionId]];
        if (url) urls.push(url);
      }
      return urls;
    }

    async function renderLayers() {
      const token = ++layerRenderToken;
      const urls = activeLayerUrls();

      // Some products have a working question/pricing flow but no per-answer
      // photos yet (spec.parts all resolve to null). Rather than leaving the
      // preview blank, show the product's own photo blurred with a "coming
      // soon" badge — pricing and the configurator itself stay fully usable.
      if (!urls.length) {
        if (token !== layerRenderToken) return;
        layerstack.innerHTML = '';
        const productImage = root.dataset.productImage;
        if (productImage) {
          const wrap = document.createElement('div');
          wrap.className = 'kf-coming-soon';
          const img = document.createElement('img');
          img.src = productImage;
          img.alt = '';
          img.draggable = false;
          const content = document.createElement('div');
          content.className = 'kf-coming-soon-content';
          const badge = document.createElement('div');
          badge.className = 'kf-coming-soon-badge';
          badge.textContent = kfUiText('Configurateur bientôt disponible');
          const note = document.createElement('p');
          note.className = 'kf-coming-soon-note';
          note.textContent = kfUiText("Vous pouvez tout de même faire vos choix ci-dessous : nous vous enverrons un rendu de votre volant une fois la commande passée, ou dès maintenant si vous préférez :");
          const previewLink = document.createElement('a');
          previewLink.className = 'kf-coming-soon-cta';
          previewLink.href = buildWhatsAppMockupUrl();
          previewLink.target = '_blank';
          previewLink.rel = 'noopener';
          previewLink.textContent = kfUiText('Recevoir ma maquette');
          content.appendChild(badge);
          content.appendChild(note);
          content.appendChild(previewLink);
          wrap.appendChild(img);
          wrap.appendChild(content);
          layerstack.appendChild(wrap);
        }
        return;
      }

      const loaded = await Promise.all(urls.map(preloadImage));
      if (token !== layerRenderToken) return; // a newer selection superseded this one

      layerstack.innerHTML = '';
      for (const img of loaded) {
        img.alt = '';
        layerstack.appendChild(img);
      }
    }

    function renderPrice() {
      const total = computeTotal();
      syncWhatsAppLinks();
      const best = findNearestVariant(total);
      if (kfNonEur) {
        const exactLocal = best && Math.abs(best.price - total) < 0.02 && kfLocalPrice[best.id] != null;
        priceEl.textContent = exactLocal ? kfFmtLocal(kfLocalPrice[best.id], 2) : ('\u2248 ' + kfFmtLocal(total * kfRate, 0));
      } else {
        priceEl.textContent = (kfIsEnglish() || kfIsHebrew() || kfIsArabic()) ? (total.toFixed(2) + ' €') : (total.toFixed(2).replace('.', ',') + ' €');
      }
      if (klarnaAmountEl && !kfNonEur) {
        const monthly = total / 4;
        klarnaAmountEl.textContent = (kfIsEnglish() || kfIsHebrew() || kfIsArabic()) ? (monthly.toFixed(2) + '€') : (monthly.toFixed(2).replace('.', ',') + '€');
      }
      if (!best) { noteEl.textContent = ''; ctaEl.dataset.priceOk = ''; updateCtaState(); return; }
      const diff = Math.abs(best.price - total);
      // A handful of price points across the catalog could only be created a
      // cent or two off their exact target (Shopify silently reserves the
      // option-value string of some previously deleted variants, blocking
      // recreation at the exact same price) — 0.02 absorbs that without
      // weakening the check for the vast majority that match exactly.
      if (diff < 0.02) {
        noteEl.textContent = '';
        ctaEl.dataset.variantId = best.id;
        ctaEl.dataset.priceOk = '1';
      } else {
        noteEl.textContent = kfIsArabic()
          ? `هذه التوليفة تتطلب عرض سعر: تواصل معنا لإتمام طلبك (فرق قدره ${kfNonEur ? kfFmtLocal(diff * kfRate, 0) : '€' + diff.toFixed(2)} عن أسعارنا الأساسية).`
          : kfIsHebrew()
          ? `שילוב זה דורש הצעת מחיר: צרו איתנו קשר כדי לסיים את ההזמנה (הפרש של ${kfNonEur ? kfFmtLocal(diff * kfRate, 0) : '€' + diff.toFixed(2)} ממחירי הבסיס שלנו).`
          : kfIsDutch()
          ? `Deze combinatie vraagt om een offerte: neem contact met ons op om je bestelling af te ronden (verschil van ${diff.toFixed(2).replace('.', ',')} € met onze standaardprijzen).`
          : kfIsGerman()
          ? `Diese Kombination erfordert ein individuelles Angebot: Kontaktieren Sie uns, um Ihre Bestellung abzuschließen (Differenz von ${diff.toFixed(2).replace('.', ',')} € zu unseren Standardpreisen).`
          : kfIsPortuguese()
          ? `Esta combinação requer um orçamento: ${kfIsBrazilian() ? 'entre em contato conosco para finalizar seu pedido' : 'contacte-nos para finalizar a sua encomenda'} (diferença de ${diff.toFixed(2).replace('.', ',')} € face aos nossos preços base).`
          : kfIsItalian()
          ? `Questa combinazione richiede un preventivo: contattaci per finalizzare il tuo ordine (differenza di ${diff.toFixed(2).replace('.', ',')} € rispetto alle nostre tariffe standard).`
          : kfIsSpanish()
          ? `Esta combinación requiere un presupuesto: contáctenos para finalizar su pedido (diferencia de ${diff.toFixed(2).replace('.', ',')} € con nuestras tarifas estándar).`
          : kfIsEnglish()
          ? `This combination requires a quote: contact us to finalize your order (€${diff.toFixed(2)} difference from our standard pricing).`
          : `Cette combinaison nécessite un devis — contactez-nous pour finaliser votre commande (écart de ${diff.toFixed(2)} € avec nos tarifs standards).`;
        delete ctaEl.dataset.variantId;
        ctaEl.dataset.priceOk = '';
      }
      updateCtaState();
    }

    function renderTextQuestion(q, div) {
      const wrap = document.createElement('div');
      wrap.className = 'kf-text-input';
      const textarea = document.createElement('textarea');
      textarea.placeholder = kfUiText(q.placeholder || '');
      textarea.value = freeTextValues[q.id] || '';
      textarea.oninput = () => { freeTextValues[q.id] = textarea.value; updateNavState(); syncWhatsAppLinks(); };
      wrap.appendChild(textarea);
      div.appendChild(wrap);
    }

    function renderFileQuestion(q, div) {
      const wrap = document.createElement('div');
      wrap.className = 'kf-file-input';
      const id = 'kf-file-' + q.id + '-' + Math.random().toString(36).slice(2, 8);

      function labelFor() {
        if (!fileNames[q.id]) return kfUiText(q.placeholder || 'Choisir un fichier');
        return fileUrls[q.id] ? fileNames[q.id] : `${fileNames[q.id]} ${kfUiText('(envoi…)')}`;
      }

      function paint() {
        wrap.innerHTML = `
          <label for="${id}">
            <span class="kf-file-icon" aria-hidden="true">📎</span>
            <span class="kf-file-name">${escapeHtml(labelFor())}</span>
          </label>
          <input type="file" id="${id}" accept="image/*,.pdf,.ai,.eps,.heic">
        `;
        wrap.querySelector('input').addEventListener('change', async (e) => {
          const file = e.target.files[0];
          if (!file) {
            fileNames[q.id] = null;
            fileUrls[q.id] = null;
            paint();
            return;
          }
          fileNames[q.id] = file.name;
          fileUrls[q.id] = null;
          paint();
          const url = await uploadToCloudinary(file, file.name);
          fileUrls[q.id] = url;
          paint();
          renderPrice();
        });
      }

      paint();
      div.appendChild(wrap);
    }

    function renderImageQuestion(q, div) {
      const answersDiv = document.createElement('div');
      answersDiv.className = 'kf-answers';
      const sortedAnswers = q.answers.slice().sort((a, b) => priceFor(q.id, a.id) - priceFor(q.id, b.id));
      for (const a of sortedAnswers) {
        const cell = document.createElement('button');
        cell.type = 'button';
        cell.className = 'kf-answer' + (config[q.id] === a.id ? ' is-selected' : '');
        cell.setAttribute('aria-pressed', config[q.id] === a.id ? 'true' : 'false');
        const delta = priceFor(q.id, a.id);
        const deltaHtml = delta ? (kfNonEur ? `<div class="kf-delta">+${kfFmtLocal(delta * kfRate, 0)}</div>` : `<div class="kf-delta">+${(kfIsSpanish() || kfIsItalian() || kfIsGerman() || kfIsDutch() || kfIsPortuguese()) ? delta.toFixed(2).replace('.', ',') : delta.toFixed(2)}€</div>`) : '';
        const label = escapeHtml(kfTranslate(a.name));
        if (a.thumbnail) {
          cell.innerHTML = `<img src="${a.thumbnail}" alt="" decoding="async"><div class="kf-lbl">${label}</div>${deltaHtml}`;
        } else {
          cell.innerHTML = `<div class="kf-placeholder-sq"><span>${label}</span></div>${deltaHtml}`;
        }
        cell.addEventListener('click', () => {
          config[q.id] = a.id;
          renderLayers();
          renderPrice();
          // Update selection state in place instead of rebuilding the answers
          // list, so the horizontal scroll position (mobile swipe row) is preserved.
          answersDiv.querySelectorAll('.kf-answer').forEach((c) => {
            const selected = c === cell;
            c.classList.toggle('is-selected', selected);
            c.setAttribute('aria-pressed', selected ? 'true' : 'false');
          });
          if (mobile) {
            // Mobile keeps the original one-question-at-a-time flow: each
            // Prev/Next click already recomputes visibleQuestions() fresh,
            // so rules-based show/hide just works without extra bookkeeping.
            updateNavState();
          } else {
            // Desktop shows every question at once — this answer may enable/
            // disable other questions (spec.rules), so rebuild the list if the
            // set of visible questions changed, keeping scroll anchored here.
            reconcileVisibility(q.id);
            updateCtaState();
          }
          kfTrack('configurator_select', {
            product_name: spec.productName,
            question_name: q.name,
            answer_name: a.name,
            question_id: q.id,
            answer_id: a.id,
            price_delta: delta || 0
          });
        });
        answersDiv.appendChild(cell);
      }
      div.appendChild(answersDiv);
    }

    function updateCtaStateDesktop() {
      // Every question is shown at once now, so the CTA is always visible —
      // only its enabled/disabled state depends on having a valid price/variant.
      const mandatoryOk = spec.questions.filter(isRequired).every(mq => !isQuestionDisabled(mq.id) ? hasAnswer(mq) : true);
      ctaEl.hidden = false;
      ctaEl.disabled = !ctaEl.dataset.priceOk || !mandatoryOk;
    }

    // Original one-question-at-a-time nav state, unchanged from before the
    // desktop redesign — mobile keeps exactly this behavior.
    function updateNavStateMobile() {
      const questions = visibleQuestions();
      const q = questions[currentIndex];
      const isLast = currentIndex >= questions.length - 1;
      const blocked = q && isRequired(q) && !hasAnswer(q);

      prevBtn.disabled = currentIndex <= 0;
      nextBtn.hidden = isLast;
      nextBtn.disabled = blocked;
      requiredHintEl.textContent = blocked ? kfUiText('Merci de répondre avant de continuer.') : '';

      updateCtaStateMobile(isLast, blocked);
    }

    function updateCtaStateMobile(isLastArg, blockedArg) {
      const questions = visibleQuestions();
      const isLast = isLastArg !== undefined ? isLastArg : currentIndex >= questions.length - 1;
      const q = questions[currentIndex];
      const blocked = blockedArg !== undefined ? blockedArg : (q && isRequired(q) && !hasAnswer(q));

      const mandatoryOk = spec.questions.filter(isRequired).every(mq => !isQuestionDisabled(mq.id) ? hasAnswer(mq) : true);

      ctaEl.hidden = !isLast;
      ctaEl.disabled = !ctaEl.dataset.priceOk || blocked || !mandatoryOk;
    }

    function updateCtaState() {
      if (mobile) updateCtaStateMobile(); else updateCtaStateDesktop();
    }

    // Kept for compatibility with callers elsewhere in this file (file/text inputs).
    function updateNavState() {
      if (mobile) updateNavStateMobile(); else updateCtaStateDesktop();
    }

    let sectionEls = [];
    let lastVisibleKey = '';

    function visibleIdsKey() {
      return visibleQuestions().map(q => q.id).join(',');
    }

    // Re-renders the whole question list only if which questions are visible
    // has actually changed (rules toggling other questions on/off), and tries
    // to keep the scroll position anchored to the question the user was on.
    function reconcileVisibility(anchorQuestionId) {
      const newKey = visibleIdsKey();
      if (newKey === lastVisibleKey) return;
      const anchorEl = anchorQuestionId
        ? sectionEls.find(el => el.dataset.questionId === anchorQuestionId)
        : null;
      const anchorOffset = anchorEl ? anchorEl.getBoundingClientRect().top - questionEl.getBoundingClientRect().top : null;
      renderQuestions();
      if (anchorOffset !== null) {
        const newAnchorEl = sectionEls.find(el => el.dataset.questionId === anchorQuestionId);
        if (newAnchorEl) {
          const delta = (newAnchorEl.getBoundingClientRect().top - questionEl.getBoundingClientRect().top) - anchorOffset;
          questionEl.scrollTop += delta;
        }
      }
      updateProgressFromScroll();
    }

    function updateProgressFromScroll() {
      if (!sectionEls.length) return;
      const containerTop = questionEl.getBoundingClientRect().top;
      let idx = 0;
      for (let i = 0; i < sectionEls.length; i++) {
        const r = sectionEls[i].getBoundingClientRect();
        if (r.top - containerTop <= 80) idx = i;
      }
      // When the last question is short, its top never scrolls within the 80px
      // threshold, so scrolling to the bottom of the list wouldn't otherwise
      // reach 100% — detect "scrolled to bottom" directly and force it there.
      const atBottom = questionEl.scrollHeight - questionEl.scrollTop - questionEl.clientHeight <= 2;
      if (atBottom) idx = sectionEls.length - 1;
      currentIndex = idx;
      progressEl.textContent = `${kfIsArabic() ? 'السؤال' : kfIsHebrew() ? 'שאלה' : kfIsDutch() ? 'Vraag' : kfIsGerman() ? 'Frage' : kfIsPortuguese() ? 'Pergunta' : kfIsItalian() ? 'Domanda' : kfIsSpanish() ? 'Pregunta' : 'Question'} ${idx + 1} / ${sectionEls.length}`;
      if (progressBarFillEl) {
        const pct = ((idx + 1) / sectionEls.length) * 100;
        progressBarFillEl.style.width = pct + '%';
      }
    }

    if (!mobile) {
      questionEl.addEventListener('scroll', () => {
        window.requestAnimationFrame(updateProgressFromScroll);
      }, { passive: true });
    }

    // Original single-question render, unchanged — mobile keeps exactly this.
    function renderCurrentQuestionMobile() {
      const questions = visibleQuestions();
      if (currentIndex >= questions.length) currentIndex = questions.length - 1;
      if (currentIndex < 0) currentIndex = 0;
      const q = questions[currentIndex];

      progressEl.textContent = questions.length ? `${kfIsArabic() ? 'السؤال' : kfIsHebrew() ? 'שאלה' : kfIsDutch() ? 'Vraag' : kfIsGerman() ? 'Frage' : kfIsPortuguese() ? 'Pergunta' : kfIsItalian() ? 'Domanda' : kfIsSpanish() ? 'Pregunta' : 'Question'} ${currentIndex + 1} / ${questions.length}` : '';
      if (progressBarFillEl) {
        const pct = questions.length ? ((currentIndex + 1) / questions.length) * 100 : 0;
        progressBarFillEl.style.width = pct + '%';
      }
      questionEl.innerHTML = '';
      if (!q) return;

      const div = document.createElement('div');
      div.className = 'kf-question';
      const h3 = document.createElement('h3');
      h3.textContent = kfTranslate(q.name);
      div.appendChild(h3);
      appendShapeQuestionNote(q, div);

      guideSlot.innerHTML = '';
      const guideUrl = guideUrlFor(q.name);
      if (guideUrl) {
        const guideBtn = document.createElement('button');
        guideBtn.type = 'button';
        guideBtn.className = 'kf-guide-link';
        guideBtn.textContent = kfUiText('En savoir plus');
        guideBtn.addEventListener('click', () => openGuidePopup(guideUrl));
        guideSlot.appendChild(guideBtn);
      }

      if (q.inputType === 'text') {
        renderTextQuestion(q, div);
      } else if (q.inputType === 'fileinput') {
        renderFileQuestion(q, div);
      } else {
        renderImageQuestion(q, div);
      }

      questionEl.appendChild(div);
      updateNavStateMobile();
    }

    function renderQuestionsDesktop() {
      const questions = visibleQuestions();
      if (currentIndex >= questions.length) currentIndex = Math.max(0, questions.length - 1);

      questionEl.innerHTML = '';
      sectionEls = [];
      guideSlot.innerHTML = '';

      questions.forEach((q, i) => {
        const div = document.createElement('div');
        div.className = 'kf-question';
        div.dataset.questionIndex = String(i);
        div.dataset.questionId = q.id;
        const h3 = document.createElement('h3');
        h3.textContent = kfTranslate(q.name);
        div.appendChild(h3);
        appendShapeQuestionNote(q, div);

        const guideUrl = guideUrlFor(q.name);
        if (guideUrl) {
          const guideBtn = document.createElement('button');
          guideBtn.type = 'button';
          guideBtn.className = 'kf-guide-link kf-guide-link--inline';
          guideBtn.textContent = kfUiText('En savoir plus');
          guideBtn.addEventListener('click', () => openGuidePopup(guideUrl));
          div.appendChild(guideBtn);
        }

        if (q.inputType === 'text') {
          renderTextQuestion(q, div);
        } else if (q.inputType === 'fileinput') {
          renderFileQuestion(q, div);
        } else {
          renderImageQuestion(q, div);
        }

        questionEl.appendChild(div);
        sectionEls.push(div);
      });

      progressEl.textContent = questions.length ? `${kfIsArabic() ? 'السؤال' : kfIsHebrew() ? 'שאלה' : kfIsDutch() ? 'Vraag' : kfIsGerman() ? 'Frage' : kfIsPortuguese() ? 'Pergunta' : kfIsItalian() ? 'Domanda' : kfIsSpanish() ? 'Pregunta' : 'Question'} 1 / ${questions.length}` : '';
      if (progressBarFillEl) {
        progressBarFillEl.style.width = questions.length ? (100 / questions.length) + '%' : '0%';
      }
      lastVisibleKey = visibleIdsKey();
      updateCtaState();
    }

    function renderQuestions() {
      if (mobile) renderCurrentQuestionMobile(); else renderQuestionsDesktop();
    }

    // `renderCurrentQuestion` is kept as an alias so existing call sites
    // (file/text input change handlers) keep working in either layout.
    function renderCurrentQuestion() {
      renderQuestions();
    }

    if (mobile) {
      prevBtn.addEventListener('click', () => {
        if (currentIndex > 0) {
          currentIndex--;
          renderCurrentQuestionMobile();
        }
      });

      nextBtn.addEventListener('click', () => {
        const questions = visibleQuestions();
        const q = questions[currentIndex];
        if (q && isRequired(q) && !hasAnswer(q)) return;
        if (currentIndex < questions.length - 1) {
          currentIndex++;
          renderCurrentQuestionMobile();
        }
      });
    } else {
      if (prevBtn) prevBtn.style.display = 'none';
      if (nextBtn) nextBtn.style.display = 'none';
      if (requiredHintEl) requiredHintEl.style.display = 'none';
    }

    // Many products gate a "type" question (e.g. "Type de Poignées") behind a
    // follow-up "<Base> en <Material>" question (e.g. "Poignées en Alcantara")
    // that only becomes enabled for one specific answer of the gate — encoded
    // as a DISABLE_QUESTION rule for every *other* answer. Reconstruct that
    // gate → leaf relationship from spec.rules so the cart/WhatsApp summary
    // can show one condensed line ("Poignées: Alcantara noir") instead of two
    // ("Type de Poignées: Alcantara" + "Poignées en Alcantara: Alcantara noir").
    function computeLeafGateInfo() {
      const gateOf = {};       // leafQuestionId -> gateQuestionId
      const consistent = {};   // leafQuestionId -> false once >1 gate referenced
      const disabledBy = {};   // leafQuestionId -> Set(answerId that disables it)
      for (const rule of (spec.rules || [])) {
        const whenClauses = rule.when || [];
        for (const then of (rule.then || [])) {
          if (then.type !== 'DISABLE_QUESTION') continue;
          const leafId = then.questionId;
          for (const w of whenClauses) {
            if (!w.path || w.path[0] !== 'questions' || w.path[2] !== 'selectedAnswer' || w.assertion !== 'is') continue;
            const gateId = w.path[1];
            if (gateOf[leafId] && gateOf[leafId] !== gateId) { consistent[leafId] = false; continue; }
            gateOf[leafId] = gateId;
            if (consistent[leafId] === undefined) consistent[leafId] = true;
            (disabledBy[leafId] = disabledBy[leafId] || new Set()).add(w.value);
          }
        }
      }
      const info = {}; // leafQuestionId -> { gateId, enablingAnswerId, baseLabel }
      for (const leafId in gateOf) {
        if (consistent[leafId] === false) continue;
        const gateQ = spec.questions.find(q => q.id === gateOf[leafId]);
        const leafQ = spec.questions.find(q => q.id === leafId);
        if (!gateQ || !leafQ) continue;
        const enabling = (gateQ.answers || []).map(a => a.id).filter(id => !(disabledBy[leafId] || new Set()).has(id));
        if (enabling.length !== 1) continue;
        const baseLabel = leafQ.name.replace(/\s+en\s+.+$/i, '').trim();
        if (!baseLabel || baseLabel === leafQ.name) continue;
        info[leafId] = { gateId: gateOf[leafId], enablingAnswerId: enabling[0], baseLabel: baseLabel };
      }
      return info;
    }

    // Trims a handful of common filler prefixes so cart/WhatsApp labels read
    // shorter — "Couleur des Surpiqures" -> "Surpiqures", "Type d'Insert"
    // would only ever appear here if not already condensed away as a gate.
    function shortenLabel(name) {
      return name
        .replace(/^Forme du volant$/i, 'Forme')
        .replace(/^Couleur\s+(des\s+|du\s+|de\s+la\s+|de\s+l['’]\s*)?/i, '')
        .replace(/^Type\s+(de\s+|d['’]\s*)/i, '')
        .trim();
    }

    function frDeltaSuffix(delta) {
      if (!delta) return '';
      return ` (+${delta.toFixed(2).replace('.', ',')} €)`;
    }

    // "Avez-vous l'Option Volant Chauffant?" -> "Option Volant Chauffant" —
    // strips question-form wording so a yes/no toggle's positive answer can
    // stand on its own as a feature tag instead of "{question}: Oui".
    function cleanToggleLabel(name) {
      return name
        .replace(/^Avez-vous\s+/i, '')
        .replace(/^(l['’]|le\s+|la\s+|les\s+)/i, '')
        .replace(/\s*\?\s*$/, '')
        .trim();
    }

    var KF_NEGATIVE_ANSWERS = new Set(['Non', 'Sans', 'Aucun', 'Aucune']);
    var KF_GENERIC_AFFIRMATIVE_ANSWERS = new Set(['Oui', 'Avec']);

    function buildLineItemProperties() {
      const leafInfo = computeLeafGateInfo();
      const suppressGateIds = new Set();
      for (const leafId in leafInfo) {
        const { gateId, enablingAnswerId } = leafInfo[leafId];
        if (!isQuestionDisabled(leafId) && config[gateId] === enablingAnswerId && config[leafId]) {
          suppressGateIds.add(gateId);
        }
      }

      const props = {};
      for (const q of spec.questions) {
        if (isQuestionDisabled(q.id)) continue;
        if (suppressGateIds.has(q.id)) continue; // condensed away — its leaf below represents it
        // Properties prefixed with "_" are recorded on the order (visible to
        // staff in admin) but hidden from customer-facing displays (cart
        // drawer, cart page, order emails) — used here to keep the cart
        // summary short: internal-only questions, declined ("Non") toggles and
        // raw uploaded-file links add noise without telling the customer
        // anything new (staff still see them on the order).
        const hideFromCustomer = q.name.indexOf('pas visible sur le configurateur') !== -1 || q.inputType === 'fileinput';
        const leaf = leafInfo[q.id];
        const displayName = shortenLabel(leaf ? leaf.baseLabel : q.name);
        const key = hideFromCustomer ? '_' + displayName : displayName;
        if (q.inputType === 'text') {
          if (freeTextValues[q.id]) props[key] = freeTextValues[q.id].trim();
        } else if (q.inputType === 'fileinput') {
          if (fileUrls[q.id]) props[key] = fileUrls[q.id];
        } else {
          const ans = config[q.id];
          const found = (q.answers || []).find(a => a.id === ans);
          if (found) {
            const foundNameTrimmed = found.name.trim();
            const isEmptyChoice = KF_NEGATIVE_ANSWERS.has(foundNameTrimmed);
            let delta = priceFor(q.id, ans);
            if (leaf) delta += priceFor(leaf.gateId, leaf.enablingAnswerId);
            // A yes/no-style toggle (exactly one "Non"/"Sans" answer) whose
            // picked answer is a content-free "Oui"/"Avec" carries no info
            // beyond the question itself — show it as a standalone feature
            // tag ("Option Volant Chauffant (+29,99 €)") instead of the
            // redundant "{question}: Oui".
            const isToggleQuestion = (q.answers || []).length === 2 && (q.answers || []).some(a => KF_NEGATIVE_ANSWERS.has(a.name.trim()));
            const isContentFreeYes = isToggleQuestion && KF_GENERIC_AFFIRMATIVE_ANSWERS.has(foundNameTrimmed);
            if (isContentFreeYes) {
              props[cleanToggleLabel(displayName) + frDeltaSuffix(delta)] = ' ';
            } else {
              // "Insert" is shown right next to the rendered preview image,
              // so repeating it as a text line in the cart/order is just
              // noise for the customer — keep it staff-only ("_" prefix).
              const isInsertLine = displayName === 'Insert';
              const finalKey = (isEmptyChoice || isInsertLine) ? '_' + displayName : key;
              props[finalKey] = foundNameTrimmed + frDeltaSuffix(delta);
            }
          }
        }
      }
      return props;
    }

    // Reverse of buildLineItemProperties(): given the properties of an
    // existing cart line (as returned by /cart.js), reconstruct the
    // question -> answer selections so "Modifier" reopens the configurator
    // showing exactly what the shopper already chose, not the defaults.
    // Best-effort — free-text/file-upload answers aren't restored.
    function restoreConfigFromCartProperties(props) {
      const leafInfo = computeLeafGateInfo();
      const stripPrice = (v) => (v || '').replace(/\s*\(\+[^)]*\)\s*$/, '').trim();
      for (const q of spec.questions) {
        if (q.inputType === 'text' || q.inputType === 'fileinput') continue;
        const leaf = leafInfo[q.id];
        const displayName = shortenLabel(leaf ? leaf.baseLabel : q.name);
        const isToggleQuestion = (q.answers || []).length === 2 && (q.answers || []).some(a => KF_NEGATIVE_ANSWERS.has(a.name.trim()));

        let rawValue = props.hasOwnProperty(displayName) ? props[displayName] : props['_' + displayName];
        if (rawValue === undefined && isToggleQuestion) {
          // Content-free "Oui"/"Avec" toggles are stored as a standalone tag —
          // the whole key is "{cleanedLabel} (+price)" with a blank value.
          const cleanedBase = cleanToggleLabel(displayName);
          const tagKey = Object.keys(props).find(k => k.indexOf(cleanedBase) === 0 && stripPrice(props[k]) === '');
          if (tagKey) {
            const aff = (q.answers || []).find(a => KF_GENERIC_AFFIRMATIVE_ANSWERS.has(a.name.trim()));
            if (aff) config[q.id] = aff.id;
            continue;
          }
        }
        if (rawValue === undefined) continue;
        const cleanValue = stripPrice(rawValue);
        const match = (q.answers || []).find(a => a.name.trim() === cleanValue);
        if (match) {
          config[q.id] = match.id;
          if (leaf) config[leaf.gateId] = leaf.enablingAnswerId;
        }
      }
    }

    // Every answer of the current configuration as readable lines for a staff
    // member. Unlike the cart summary this keeps the "_"-prefixed properties
    // (Insert, stitching colour, declined options, uploaded photo): they are
    // hidden from the customer's cart but are exactly what staff needs.
    function waSpecLines() {
      const props = buildLineItemProperties();
      const textLabels = new Set(spec.questions.filter(q => q.inputType === 'text').map(q => shortenLabel(q.name)));
      const fileLabels = new Set(spec.questions.filter(q => q.inputType === 'fileinput').map(q => shortenLabel(q.name)));
      const lines = [];
      for (const k of Object.keys(props)) {
        const raw = k.replace(/^_/, '').trim();
        let label = raw.replace(/\s*\(pas visible sur le configurateur\)\s*/i, ' du volant').trim();
        let value = String(props[k] == null ? '' : props[k]).trim();
        if (fileLabels.has(raw)) label = 'Photo du volant actuel';
        else if (textLabels.has(raw)) label = 'Précisions (modèle, année, souhaits)';
        if (!value) { lines.push(label + ' : Oui'); continue; } // content-free "Oui" toggle: the label is the info
        if (value.length > 500) value = value.slice(0, 500) + '…';
        lines.push(label + ' : ' + value);
      }
      return lines;
    }

    function waTotalText() {
      const total = computeTotal();
      return ((kfIsEnglish() || kfIsHebrew() || kfIsArabic()) ? total.toFixed(2) : total.toFixed(2).replace('.', ',')) + ' €';
    }

    function syncWhatsAppLinks() {
      if (!spec) return;
      try {
        kfWaSyncLinks({
          name: spec.productName || '',
          url: productHandle ? location.origin + '/products/' + productHandle : '',
          lines: touched ? waSpecLines() : null,
          total: touched ? waTotalText() : null
        });
      } catch (e) { /* keep the previous links */ }
    }

    function buildWhatsAppMockupUrl() {
      const lines = waSpecLines();
      lines.push('Total : ' + waTotalText());
      const modelSuffix = spec.productName ? (' pour le ' + spec.productName) : '';
      const intro = kfIsArabic()
        ? "مرحبًا، هذه تهيئتي" + (spec.productName ? (' لـ ' + spec.productName) : '') + "، هل يمكنكم إرسال معاينة مرئية لي قبل أن أقدّم الطلب؟"
        : kfIsHebrew()
        ? "שלום, הנה התצורה שלי" + (spec.productName ? (' עבור ' + spec.productName) : '') + ", אפשר לשלוח לי תצוגה מקדימה חזותית לפני שאבצע את ההזמנה?"
        : kfIsDutch()
        ? "Hallo, hier is mijn configuratie" + (spec.productName ? (' voor de ' + spec.productName) : '') + ", kunnen jullie me een visueel voorbeeld sturen voordat ik mijn bestelling plaats?"
        : kfIsGerman()
        ? "Guten Tag, hier ist meine Konfiguration" + (spec.productName ? (' für ' + spec.productName) : '') + ", können Sie mir eine visuelle Vorschau senden, bevor ich die Bestellung aufgebe?"
        : kfIsPortuguese()
        ? (kfIsBrazilian()
          ? "Olá, esta é a minha configuração" + (spec.productName ? (' para o ' + spec.productName) : '') + ", vocês podem me enviar uma prévia visual antes de eu fazer o pedido?"
          : "Olá, esta é a minha configuração" + (spec.productName ? (' para o ' + spec.productName) : '') + ", podem enviar-me uma pré-visualização antes de eu fazer a encomenda?")
        : kfIsItalian()
        ? "Buongiorno, ecco la mia configurazione" + (spec.productName ? (' per il ' + spec.productName) : '') + ", potete inviarmi un'anteprima visiva prima che effettui l'ordine?"
        : kfIsSpanish()
        ? "Hola, esta es mi configuración" + (spec.productName ? (' para el ' + spec.productName) : '') + ", ¿pueden enviarme una vista previa antes de hacer el pedido?"
        : kfIsEnglish()
        ? "Hello, here is my configuration" + (spec.productName ? (' for the ' + spec.productName) : '') + ", can you send me a visual preview before I place my order?"
        : "Bonjour, voici ma configuration" + modelSuffix + ", pouvez-vous m'envoyer un aperçu visuel avant que je passe commande ?";
      const text = lines.length ? (intro + '\n\n' + lines.join('\n')) : intro;
      return 'https://api.whatsapp.com/send/?phone=' + KF_WHATSAPP_PHONE + '&text=' + encodeURIComponent(text) + '&type=phone_number&app_absent=0';
    }

    async function composeConfigImageBlob() {
      const urls = activeLayerUrls();
      // No photo layers configured for this product yet (same "sans calque"
      // case as the coming-soon preview) — returning null here means no blank
      // composed image gets uploaded/attached, so the cart drawer's thumbnail
      // falls back to the product's own photo instead of an empty square.
      if (!urls.length) return null;
      const imgs = await Promise.all(urls.map(preloadImage));
      const size = 900;
      const canvas = document.createElement('canvas');
      canvas.width = size;
      canvas.height = size;
      const ctx = canvas.getContext('2d');
      for (const img of imgs) {
        if (img.complete && img.naturalWidth) ctx.drawImage(img, 0, 0, size, size);
      }
      return new Promise((resolve) => canvas.toBlob((blob) => resolve(blob), 'image/png'));
    }

    // Shopify's cookie banner (z-index 2,000,000) is drawn right over this button: while it is still
    // open, ignore the click so answering the banner can never add the product to the cart.
    function kfCookieBannerOpen() {
      const b = document.getElementById('shopify-pc__banner');
      if (!b || b.hidden) return false;
      const cs = getComputedStyle(b);
      return cs.display !== 'none' && cs.visibility !== 'hidden' && b.getBoundingClientRect().height > 0;
    }

    ctaEl.addEventListener('click', async () => {
      const variantId = ctaEl.dataset.variantId;
      if (!variantId) return;
      if (kfCookieBannerOpen()) return;
      ctaEl.disabled = true;
      const originalLabel = ctaEl.textContent;
      ctaEl.textContent = kfUiText('Préparation de votre configuration…');
      try {
        const properties = buildLineItemProperties();
        try {
          const blob = await composeConfigImageBlob();
          if (blob) {
            const imageUrl = await uploadToCloudinary(blob, 'configuration.png');
            // Underscore prefix: kept on the order for staff, but hidden from
            // the customer-facing cart drawer's property list (its own
            // dedicated thumbnail lookup in cart-item-drawer.liquid reads
            // this same key directly, independent of that list's filter).
            if (imageUrl) properties['_Photo de votre configuration'] = imageUrl;
          }
        } catch (e) { /* image composition/upload failure should not block the order */ }

        ctaEl.textContent = kfUiText('Ajout en cours…');
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            items: [{
              id: Number(variantId),
              quantity: 1,
              properties: properties
            }]
          })
        });
        if (!res.ok) throw new Error('cart add failed');
        // Editing an existing cart line ("Modifier"): the new, reconfigured
        // line was just added above — now remove the original line so the
        // shopper ends up with one updated item, not two.
        const editKeyMatch = location.search.match(/[?&]kf_edit_key=([^&]+)/);
        if (editKeyMatch) {
          try {
            await fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ id: decodeURIComponent(editKeyMatch[1]), quantity: 0 })
            });
          } catch (e) { /* the new line was added either way; not fatal */ }
        }
        const total = computeTotal();
        kfTrack('add_to_cart', {
          currency: 'EUR',
          value: total,
          items: [{ item_id: String(variantId), item_name: spec.productName, price: total, quantity: 1 }]
        });
        // This theme (Adastra) uses its own EventBus, not plain DOM CustomEvents —
        // this refreshes the cart sections and opens the sliding cart drawer.
        if (window.themeCore && window.themeCore.EventBus) {
          window.themeCore.EventBus.emit('cart:drawer:refresh-and-open');
        }
        // Close the configurator modal (instead of navigating to /cart) so the
        // drawer opened above is visible.
        const modal = document.querySelector('[data-kf-modal]');
        if (modal) {
          modal.classList.remove('kf-modal--open');
          document.body.style.position = '';
          document.body.style.top = '';
          document.body.style.left = '';
          document.body.style.right = '';
          document.body.style.width = '';
          document.body.style.overflow = '';
          setTimeout(() => { modal.setAttribute('hidden', ''); }, 250);
        }
        ctaEl.textContent = originalLabel;
        ctaEl.disabled = false;
      } catch (e) {
        ctaEl.textContent = kfUiText('Erreur — réessayez');
        setTimeout(() => { ctaEl.textContent = originalLabel; ctaEl.disabled = false; }, 2000);
      }
    });

    fetch(specUrl).then(r => r.json()).then(async data => {
      spec = data;
      config = { ...spec.defaultConfiguration };
      const editKeyMatch = location.search.match(/[?&]kf_edit_key=([^&]+)/);
      if (editKeyMatch) {
        try {
          const cartRes = await fetch('/cart.js');
          const cart = await cartRes.json();
          const line = (cart.items || []).find(it => it.key === decodeURIComponent(editKeyMatch[1]));
          if (line && line.properties) { restoreConfigFromCartProperties(line.properties); touched = true; }
        } catch (e) { /* fall back to defaults */ }
      }
      ctaEl.textContent = kfUiText('Valider la configuration');

      const initialUrls = new Set();
      activeLayerUrls().forEach(u => initialUrls.add(u));
      const firstQuestion = visibleQuestions()[0];
      if (firstQuestion) thumbnailUrlsFor(firstQuestion).forEach(u => initialUrls.add(u));
      initialUrls.forEach(u => warmedThumbs.add(u));

      if (loadingBarEl) loadingBarEl.style.width = '0%';
      await preloadWithProgress(initialUrls, (ratio) => {
        if (loadingBarEl) loadingBarEl.style.width = Math.round(ratio * 100) + '%';
      });

      renderLayers();
      renderCurrentQuestion();
      renderPrice();

      if (loadingEl) {
        loadingEl.classList.add('kf-loading-overlay--fading');
        setTimeout(() => loadingEl.setAttribute('hidden', ''), 300);
      }

      // Warm every remaining question's thumbnails in the background right away,
      // so navigating through the configurator never shows a blank/loading icon.
      warmupRemainingThumbnails();
    });
  }

  document.querySelectorAll('[data-kf-configurator]').forEach(function (root) {
    // Defer the heavy init (paginated variant fetch, spec-JSON fetch, image
    // preload/warmup) until the shopper actually opens the configurator, or
    // after an idle window if they never do — instead of firing it
    // unconditionally on every product-page load, which was adding ~18s of
    // client-side work before the page was even interactive.
    kfWaPreSpec(root);
    let kfStarted = false;
    function kfStart() {
      if (kfStarted) return;
      kfStarted = true;
      initConfigurator(root);
    }
    document.querySelectorAll('[data-kf-open]').forEach(function (btn) {
      btn.addEventListener('click', kfStart);
    });
    if ('requestIdleCallback' in window) {
      requestIdleCallback(kfStart, { timeout: 4000 });
    } else {
      setTimeout(kfStart, 2500);
    }
  });

  // Move modals to the end of <body> so `position: fixed` always covers the
  // full viewport, regardless of any ancestor that would otherwise contain it.
  document.querySelectorAll('[data-kf-modal]').forEach(function (modal) {
    document.body.appendChild(modal);
  });

  let kfSavedScrollY = 0;

  function lockBodyScroll() {
    kfSavedScrollY = window.scrollY || window.pageYOffset;
    document.body.style.position = 'fixed';
    document.body.style.top = -kfSavedScrollY + 'px';
    document.body.style.left = '0';
    document.body.style.right = '0';
    document.body.style.width = '100%';
    document.body.style.overflow = 'hidden';
  }

  function unlockBodyScroll() {
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.left = '';
    document.body.style.right = '';
    document.body.style.width = '';
    document.body.style.overflow = '';
    window.scrollTo(0, kfSavedScrollY);
  }

  document.querySelectorAll('[data-kf-modal]').forEach(function (modal) {
    modal.addEventListener('touchmove', function (e) {
      if (e.target === modal || e.target.classList.contains('kf-modal-backdrop')) {
        e.preventDefault();
      }
    }, { passive: false });
  });

  document.querySelectorAll('[data-kf-open]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      const modal = document.querySelector('[data-kf-modal]');
      if (!modal) return;
      modal.removeAttribute('hidden');
      lockBodyScroll();
      requestAnimationFrame(() => {
        requestAnimationFrame(() => modal.classList.add('kf-modal--open'));
      });
      kfTrack('configurator_open', {});
    });
  });

  document.querySelectorAll('[data-kf-close]').forEach(function (el) {
    el.addEventListener('click', function () {
      const modal = document.querySelector('[data-kf-modal]');
      if (!modal) return;
      modal.classList.remove('kf-modal--open');
      unlockBodyScroll();
      setTimeout(() => { modal.setAttribute('hidden', ''); }, 250);
    });
  });

  // The cart drawer's "Modifier" button links back here with ?kf_edit=1 —
  // reopen the configurator automatically so the shopper lands straight back
  // in it instead of on a bare product page. (Starts from the defaults; it
  // does not restore the prior cart line's exact selections.)
  if (/[?&]kf_edit=1(&|$)/.test(location.search)) {
    const openBtn = document.querySelector('[data-kf-open]');
    if (openBtn) openBtn.click();
  }
})();

// The Judge.me review-widget header shows the average rating as a bare number
// ("4.8") with no stars next to it — this inserts a matching star row to its
// left. The widget is a client-rendered Vue app, so we watch for the number
// to appear rather than assuming it's there at script-load time.
(function () {
  function starsFor(rating) {
    const full = Math.round(rating * 2) / 2; // nearest half-star
    const span = document.createElement('span');
    span.className = 'kf-jdgm-avg-stars';
    span.setAttribute('aria-hidden', 'true');
    let html = '';
    for (let i = 1; i <= 5; i++) {
      html += i <= full ? '★' : '☆';
    }
    span.innerHTML = html;
    return span;
  }

  function addStars(container) {
    if (container.dataset.kfStarsAdded) return;
    const numberEl = container.querySelector('.jm-text');
    if (!numberEl) return;
    const rating = parseFloat(numberEl.textContent.replace(',', '.'));
    if (Number.isNaN(rating)) return;
    container.dataset.kfStarsAdded = '1';
    numberEl.parentNode.insertBefore(starsFor(rating), numberEl);
  }

  function scan() {
    document.querySelectorAll('.jm-average-rating-display').forEach(addStars);
  }

  scan();
  new MutationObserver(scan).observe(document.body, { childList: true, subtree: true });
})();

